// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FaUsers,
//   FaFileAlt,
//   FaClock,
//   FaCheck,
//   FaTimes,
//   FaDownload,
//   FaChartBar,
//   FaUserCheck,
//   FaUserTimes,
//   FaTrash,
//   FaEye,
//   FaSearch,
//   FaFilter,
//   FaSort,
//   FaEdit,
//   FaBan,
//   FaCheckCircle,
//   FaExclamationTriangle,
//   FaCog,
//   FaFilePdf,
//   FaFileWord,
//   FaFilePowerpoint,
//   FaImage,
//   FaEllipsisV,
//   FaEnvelope,
//   FaFlag,
//   FaReply,
//   FaComments,
//   FaPaperPlane,
//   FaCalculator,
//   FaGlobe,
//   FaMicrophoneSlash,
//   FaMicrophone,
//   FaUserSlash,
//   FaUserPlus,
//   FaVolumeMute,
//   FaThumbsUp,
//   FaThumbsDown,
//   FaSpinner,
//   FaShieldAlt,
//   FaRocket,
//   FaArrowRight,
//   FaCalendarAlt,
//   FaBuilding,
//   FaTrophy,
//   FaStar,
//   FaAward,
//   FaTimesCircle,
// } from "react-icons/fa";
// import { HiOutlineSparkles } from "react-icons/hi";
// import axios from "axios";
// import toast from "react-hot-toast";
// import Loader from "../components/common/Loader";
// import CGPASchemeManager from "../components/cgpa/CGPASchemeManager";
// import AdminSGPA from "../components/sgpa/AdminSGPA";
// import ResultURLManager from "../components/admin/ResultURLManager";
// import RecentResultsManager from "../components/admin/RecentResultsManager";

// const AdminDashboard = () => {
//   const navigate = useNavigate();
//   const { user, isAuthenticated } = useSelector((state) => state.auth);
//   const [loading, setLoading] = useState(true);
//   const [dashboardData, setDashboardData] = useState(null);
//   const [pendingNotes, setPendingNotes] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [contacts, setContacts] = useState([]);
//   const [contactStats, setContactStats] = useState({});
//   const [reportedComments, setReportedComments] = useState([]);
//   const [reportedNotes, setReportedNotes] = useState([]);
//   const [selectedNote, setSelectedNote] = useState(null);
//   const [selectedContact, setSelectedContact] = useState(null);
//   const [rejectionReason, setRejectionReason] = useState("");
//   const [showRejectModal, setShowRejectModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [showReplyModal, setShowReplyModal] = useState(false);
//   const [replyText, setReplyText] = useState("");
//   const [activeTab, setActiveTab] = useState("pending");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [branchFilter, setBranchFilter] = useState("all");
//   const [selectedNotes, setSelectedNotes] = useState([]);
//   const [showBulkActions, setShowBulkActions] = useState(false);
//   const [dateRange, setDateRange] = useState({ start: "", end: "" });
//   const [isDarkMode, setIsDarkMode] = useState(false);

//   // State for muted/banned users
//   const [mutedUsers, setMutedUsers] = useState([]);
//   const [bannedUsers, setBannedUsers] = useState([]);
//   const [loadingMutedBanned, setLoadingMutedBanned] = useState(false);
//   const [mutedSearchTerm, setMutedSearchTerm] = useState("");
//   const [bannedSearchTerm, setBannedSearchTerm] = useState("");

//   // Dark mode detection
//   useEffect(() => {
//     const checkDarkMode = () => {
//       const dark =
//         document.documentElement.getAttribute("data-theme") === "dark";
//       setIsDarkMode(dark);
//     };
//     checkDarkMode();
//     const observer = new MutationObserver(checkDarkMode);
//     observer.observe(document.documentElement, {
//       attributes: true,
//       attributeFilter: ["data-theme"],
//     });
//     return () => observer.disconnect();
//   }, []);

//   const isAdmin = user?.role === "admin";
//   const isModerator = user?.role === "moderator";

//   const branches = ["CSE", "ISE", "ECE", "EEE", "MECH", "CIVIL", "AIML", "DS"];
//   const statuses = ["pending", "approved", "rejected"];

//   useEffect(() => {
//     if (!isAuthenticated || (!isAdmin && !isModerator)) {
//       navigate("/");
//       toast.error("Unauthorized access");
//       return;
//     }
//     fetchPendingNotes();
//     fetchReportedComments();
//     fetchReportedNotes();
//     fetchContacts();
//     fetchContactStats();
//     if (isAdmin) {
//       fetchDashboardData();
//       fetchUsers();
//       fetchMutedAndBannedUsers();
//     }
//   }, [isAuthenticated, user, navigate]);

//   const fetchMutedAndBannedUsers = async () => {
//     setLoadingMutedBanned(true);
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         "http://localhost:5001/api/admin/users",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       const allUsers = response.data.users || [];
//       const now = new Date();
//       const muted = allUsers.filter(
//         (u) =>
//           u.isMuted === true && (!u.mutedUntil || new Date(u.mutedUntil) > now),
//       );
//       const banned = allUsers.filter(
//         (u) =>
//           u.isBanned === true &&
//           (!u.bannedUntil || new Date(u.bannedUntil) > now),
//       );
//       setMutedUsers(muted);
//       setBannedUsers(banned);
//     } catch (error) {
//       console.error("Fetch muted/banned users error:", error);
//       toast.error("Failed to fetch muted/banned users");
//     } finally {
//       setLoadingMutedBanned(false);
//     }
//   };

//   const handleUnmuteUserFromAdmin = async (userId) => {
//     try {
//       const token = localStorage.getItem("token");
//       await axios.post(
//         `http://localhost:5001/api/chat/user/${userId}/unmute`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       toast.success("User unmuted successfully");
//       fetchMutedAndBannedUsers();
//       fetchUsers();
//     } catch (error) {
//       console.error("Unmute error:", error);
//       toast.error(error.response?.data?.message || "Failed to unmute user");
//     }
//   };

//   const handleUnbanUserFromAdmin = async (userId) => {
//     try {
//       const token = localStorage.getItem("token");
//       await axios.post(
//         `http://localhost:5001/api/chat/user/${userId}/unban`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       toast.success("User unbanned successfully");
//       fetchMutedAndBannedUsers();
//       fetchUsers();
//     } catch (error) {
//       console.error("Unban error:", error);
//       toast.error(error.response?.data?.message || "Failed to unban user");
//     }
//   };

//   const fetchDashboardData = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         "http://localhost:5001/api/admin/dashboard",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       setDashboardData(response.data);
//     } catch (error) {
//       console.error("Fetch dashboard error:", error);
//       toast.error("Failed to fetch dashboard data");
//     }
//   };

//   const fetchPendingNotes = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         "http://localhost:5001/api/admin/notes?status=pending",
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       setPendingNotes(response.data.notes || []);
//     } catch (error) {
//       console.error("Fetch pending notes error:", error);
//       toast.error("Failed to fetch pending notes");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchUsers = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         "http://localhost:5001/api/admin/users",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       setUsers(response.data.users || []);
//     } catch (error) {
//       console.error("Fetch users error:", error);
//     }
//   };

//   const fetchContacts = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get("http://localhost:5001/api/contact", {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setContacts(response.data.contacts || []);
//     } catch (error) {
//       console.error("Fetch contacts error:", error);
//       toast.error("Failed to fetch contact messages");
//     }
//   };

//   const fetchContactStats = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         "http://localhost:5001/api/contact/stats/summary",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       setContactStats(response.data);
//     } catch (error) {
//       console.error("Fetch contact stats error:", error);
//     }
//   };

//   const handleUpdateContactStatus = async (id, status) => {
//     try {
//       const token = localStorage.getItem("token");
//       await axios.put(
//         `http://localhost:5001/api/contact/${id}`,
//         { status },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       toast.success("Status updated");
//       fetchContacts();
//       fetchContactStats();
//     } catch (error) {
//       toast.error("Failed to update status");
//     }
//   };

//   const handleReplyContact = async () => {
//     if (!replyText.trim()) {
//       toast.error("Please enter a reply");
//       return;
//     }
//     try {
//       const token = localStorage.getItem("token");
//       await axios.put(
//         `http://localhost:5001/api/contact/${selectedContact._id}`,
//         { status: "replied", reply: replyText },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       toast.success("Reply sent");
//       setShowReplyModal(false);
//       setSelectedContact(null);
//       setReplyText("");
//       fetchContacts();
//       fetchContactStats();
//     } catch (error) {
//       toast.error("Failed to send reply");
//     }
//   };

//   const handleDeleteContact = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this message?"))
//       return;
//     try {
//       const token = localStorage.getItem("token");
//       await axios.delete(`http://localhost:5001/api/contact/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       toast.success("Message deleted");
//       fetchContacts();
//       fetchContactStats();
//     } catch (error) {
//       toast.error("Failed to delete message");
//     }
//   };

//   const fetchReportedComments = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         "http://localhost:5001/api/admin/comments/reported",
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       setReportedComments(response.data.comments || []);
//     } catch (error) {
//       console.error("Fetch reported comments error:", error);
//     }
//   };

//   const fetchReportedNotes = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         "http://localhost:5001/api/admin/notes/reported",
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       setReportedNotes(response.data.notes || []);
//     } catch (error) {
//       console.error("Fetch reported notes error:", error);
//       toast.error("Failed to fetch reported notes");
//     }
//   };

//   const handleModerateComment = async (commentId, action, moderationNote) => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         `http://localhost:5001/api/admin/reported-comments/${commentId}/moderate`,
//         { action, moderationNote },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success(response.data.message);
//         fetchReportedComments();
//         if (isAdmin) fetchDashboardData();
//       }
//     } catch (error) {
//       console.error("Moderate comment error:", error);
//       toast.error("Failed to moderate comment");
//     }
//   };

//   const handleModerateNote = async (noteId, action, moderationNote) => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         `http://localhost:5001/api/admin/reported-notes/${noteId}/moderate`,
//         { action, moderationNote },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success(response.data.message);
//         fetchReportedNotes();
//         if (isAdmin) fetchDashboardData();
//       }
//     } catch (error) {
//       console.error("Moderate note error:", error);
//       toast.error("Failed to moderate note");
//     }
//   };

//   const handleApprove = async (noteId) => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         `http://localhost:5001/api/admin/notes/${noteId}/approve`,
//         {
//           comments: `Approved by ${user?.role === "admin" ? "Admin" : "Moderator"}`,
//         },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success("Note approved successfully");
//         fetchPendingNotes();
//         if (isAdmin) fetchDashboardData();
//       }
//     } catch (error) {
//       toast.error("Failed to approve note");
//     }
//   };

//   const handleReject = async () => {
//     if (!rejectionReason.trim()) {
//       toast.error("Please provide a rejection reason");
//       return;
//     }
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         `http://localhost:5001/api/admin/notes/${selectedNote._id}/reject`,
//         { reason: rejectionReason },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success("Note rejected");
//         setShowRejectModal(false);
//         setRejectionReason("");
//         setSelectedNote(null);
//         fetchPendingNotes();
//         if (isAdmin) fetchDashboardData();
//       }
//     } catch (error) {
//       toast.error("Failed to reject note");
//     }
//   };

//   const handleDeleteNote = async () => {
//     if (!isAdmin) {
//       toast.error("Only admins can delete notes");
//       return;
//     }
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.delete(
//         `http://localhost:5001/api/admin/notes/${selectedNote._id}`,
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success("Note deleted permanently");
//         setShowDeleteModal(false);
//         setSelectedNote(null);
//         fetchPendingNotes();
//         fetchDashboardData();
//       }
//     } catch (error) {
//       toast.error("Failed to delete note");
//     }
//   };

//   const handleBulkApprove = async () => {
//     if (selectedNotes.length === 0) {
//       toast.error("Select notes to approve");
//       return;
//     }
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         "http://localhost:5001/api/admin/notes/bulk/approve",
//         { noteIds: selectedNotes },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success(response.data.message);
//         setSelectedNotes([]);
//         setShowBulkActions(false);
//         fetchPendingNotes();
//         if (isAdmin) fetchDashboardData();
//       }
//     } catch (error) {
//       toast.error("Failed to approve notes");
//     }
//   };

//   const handleBulkReject = async () => {
//     if (selectedNotes.length === 0) {
//       toast.error("Select notes to reject");
//       return;
//     }
//     const reason = prompt("Enter rejection reason for all selected notes:");
//     if (!reason) return;
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         "http://localhost:5001/api/admin/notes/bulk/reject",
//         { noteIds: selectedNotes, reason },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success(response.data.message);
//         setSelectedNotes([]);
//         setShowBulkActions(false);
//         fetchPendingNotes();
//         if (isAdmin) fetchDashboardData();
//       }
//     } catch (error) {
//       toast.error("Failed to reject notes");
//     }
//   };

//   const handleToggleUserStatus = async (userId) => {
//     if (!isAdmin) {
//       toast.error("Only admins can manage users");
//       return;
//     }
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         `http://localhost:5001/api/admin/users/${userId}/toggle-status`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success(response.data.message);
//         fetchUsers();
//         fetchMutedAndBannedUsers();
//       }
//     } catch (error) {
//       toast.error("Failed to toggle user status");
//     }
//   };

//   const handleChangeUserRole = async (userId, newRole) => {
//     if (!isAdmin) {
//       toast.error("Only admins can change user roles");
//       return;
//     }
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.put(
//         `http://localhost:5001/api/admin/users/${userId}/role`,
//         { role: newRole },
//         { headers: { Authorization: `Bearer ${token}` } },
//       );
//       if (response.data.success) {
//         toast.success("User role updated");
//         fetchUsers();
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to update role");
//     }
//   };

//   if (loading) return <Loader />;

//   // Helper functions for styling
//   const getTextColorStatic = (isDarkMode) =>
//     isDarkMode ? "#f1f5f9" : "#1e293b";
//   const getTextSecondaryStatic = (isDarkMode) =>
//     isDarkMode ? "#94a3b8" : "#64748b";
//   const getBorderColorStatic = (isDarkMode) =>
//     isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
//   const getCardBackgroundStatic = (isDarkMode) =>
//     isDarkMode ? "rgba(30, 30, 45, 0.8)" : "rgba(255, 255, 255, 0.9)";
//   const getInputBackgroundStatic = (isDarkMode) =>
//     isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff";

//   const filteredMutedUsers = mutedUsers.filter(
//     (u) =>
//       u.name?.toLowerCase().includes(mutedSearchTerm.toLowerCase()) ||
//       u.email?.toLowerCase().includes(mutedSearchTerm.toLowerCase()) ||
//       u.usn?.toLowerCase().includes(mutedSearchTerm.toLowerCase()),
//   );

//   const filteredBannedUsers = bannedUsers.filter(
//     (u) =>
//       u.name?.toLowerCase().includes(bannedSearchTerm.toLowerCase()) ||
//       u.email?.toLowerCase().includes(bannedSearchTerm.toLowerCase()) ||
//       u.usn?.toLowerCase().includes(bannedSearchTerm.toLowerCase()),
//   );

//   return (
//     <div
//       style={{
//         maxWidth: "1400px",
//         margin: "0 auto",
//         padding: "2rem",
//         background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
//         minHeight: "100vh",
//         position: "relative",
//       }}
//     >
//       {/* Animated Background Grid */}
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           pointerEvents: "none",
//           zIndex: 0,
//           backgroundImage: `radial-gradient(circle at 1px 1px, ${isDarkMode ? "rgba(139,92,246,0.1)" : "rgba(139,92,246,0.08)"} 1px, transparent 1px)`,
//           backgroundSize: "40px 40px",
//         }}
//       />

//       {/* Floating Gradient Orbs */}
//       <motion.div
//         animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
//         transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
//         style={{
//           position: "fixed",
//           top: "10%",
//           left: "-5%",
//           width: "300px",
//           height: "300px",
//           background:
//             "radial-gradient(circle, rgba(139,92,246,0.3) 0%, transparent 70%)",
//           borderRadius: "50%",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       />
//       <motion.div
//         animate={{ x: [0, -100, 0], y: [0, 80, 0] }}
//         transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
//         style={{
//           position: "fixed",
//           bottom: "10%",
//           right: "-5%",
//           width: "350px",
//           height: "350px",
//           background:
//             "radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 70%)",
//           borderRadius: "50%",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       />

//       {/* Header */}
//       <motion.div
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6, type: "spring", stiffness: 300 }}
//         style={{
//           background: "linear-gradient(135deg, #1e1b4b 0%, #2e1065 100%)",
//           color: "white",
//           padding: "2rem",
//           borderRadius: "28px",
//           marginBottom: "2rem",
//           position: "relative",
//           zIndex: 1,
//           overflow: "hidden",
//         }}
//       >
//         <motion.div
//           animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.1, 0.3] }}
//           transition={{ duration: 4, repeat: Infinity }}
//           style={{
//             position: "absolute",
//             top: -50,
//             right: -50,
//             width: 200,
//             height: 200,
//             background:
//               "radial-gradient(circle, rgba(139,92,246,0.4) 0%, transparent 70%)",
//             borderRadius: "50%",
//           }}
//         />
//         <div style={{ position: "relative", zIndex: 1 }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "0.75rem",
//               marginBottom: "0.5rem",
//             }}
//           >
//             <div
//               style={{
//                 background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//                 width: "50px",
//                 height: "50px",
//                 borderRadius: "16px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <HiOutlineSparkles size={28} color="white" />
//             </div>
//             <h1
//               style={{ fontSize: "2rem", fontWeight: "bold", color: "white" }}
//             >
//               {isAdmin ? "Admin Dashboard" : "Moderator Dashboard"}
//             </h1>
//           </div>
//           <p
//             style={{
//               opacity: 0.9,
//               color: "rgba(255,255,255,0.9)",
//               marginLeft: "3rem",
//             }}
//           >
//             Welcome back, {user?.name}.{" "}
//             {isModerator && "You can review and approve notes."}
//           </p>
//         </div>
//       </motion.div>

//       {/* Stats Cards Grid */}
//       {dashboardData && isAdmin && (
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.1 }}
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//             gap: "1.5rem",
//             marginBottom: "2rem",
//             position: "relative",
//             zIndex: 1,
//           }}
//         >
//           <StatCard
//             icon={<FaClock />}
//             label="Pending Notes"
//             value={dashboardData.stats.pendingNotes}
//             color="#f59e0b"
//             isDarkMode={isDarkMode}
//           />
//           <StatCard
//             icon={<FaCheckCircle />}
//             label="Approved Notes"
//             value={dashboardData.stats.approvedNotes}
//             color="#10b981"
//             isDarkMode={isDarkMode}
//           />
//           <StatCard
//             icon={<FaTimesCircle />}
//             label="Rejected Notes"
//             value={dashboardData.stats.rejectedNotes}
//             color="#ef4444"
//             isDarkMode={isDarkMode}
//           />
//           <StatCard
//             icon={<FaFlag />}
//             label="Reported Notes"
//             value={reportedNotes.length}
//             color="#8b5cf6"
//             isDarkMode={isDarkMode}
//           />
//           <StatCard
//             icon={<FaComments />}
//             label="Reported Comments"
//             value={reportedComments.length}
//             color="#06b6d4"
//             isDarkMode={isDarkMode}
//           />
//           <StatCard
//             icon={<FaUsers />}
//             label="Total Users"
//             value={dashboardData.stats.totalUsers}
//             color="#8b5cf6"
//             isDarkMode={isDarkMode}
//           />
//           <StatCard
//             icon={<FaEnvelope />}
//             label="Contact Messages"
//             value={contactStats.total || 0}
//             color="#f59e0b"
//             isDarkMode={isDarkMode}
//           />
//           <StatCard
//             icon={<FaMicrophoneSlash />}
//             label="Muted Users"
//             value={mutedUsers.length}
//             color="#f59e0b"
//             isDarkMode={isDarkMode}
//           />
//           <StatCard
//             icon={<FaBan />}
//             label="Banned Users"
//             value={bannedUsers.length}
//             color="#ef4444"
//             isDarkMode={isDarkMode}
//           />
//         </motion.div>
//       )}

//       {/* Navigation Tabs */}
//       <div
//         style={{
//           display: "flex",
//           gap: "0.5rem",
//           borderBottom: `2px solid ${getBorderColorStatic(isDarkMode)}`,
//           marginBottom: "2rem",
//           flexWrap: "wrap",
//           paddingBottom: "0.5rem",
//           background: getCardBackgroundStatic(isDarkMode),
//           backdropFilter: "blur(20px)",
//           padding: "0.5rem 1rem",
//           borderRadius: "20px",
//           position: "relative",
//           zIndex: 1,
//         }}
//       >
//         <TabButton
//           active={activeTab === "pending"}
//           onClick={() => setActiveTab("pending")}
//           icon={<FaClock color="#f59e0b" />}
//           label={`Pending (${pendingNotes.length})`}
//           isDarkMode={isDarkMode}
//         />
//         <TabButton
//           active={activeTab === "reported-notes"}
//           onClick={() => setActiveTab("reported-notes")}
//           icon={<FaFlag color="#ef4444" />}
//           label={`Reported Notes (${reportedNotes.length})`}
//           isDarkMode={isDarkMode}
//         />
//         <TabButton
//           active={activeTab === "reported-comments"}
//           onClick={() => setActiveTab("reported-comments")}
//           icon={<FaComments color="#06b6d4" />}
//           label={`Reported Comments (${reportedComments.length})`}
//           isDarkMode={isDarkMode}
//         />
//         <TabButton
//           active={activeTab === "contacts"}
//           onClick={() => setActiveTab("contacts")}
//           icon={<FaEnvelope color="#8b5cf6" />}
//           label={`Contacts (${contactStats.total || 0})`}
//           isDarkMode={isDarkMode}
//         />
//         <TabButton
//           active={activeTab === "cgpa-schemes"}
//           onClick={() => setActiveTab("cgpa-schemes")}
//           icon={<FaCalculator color="#8b5cf6" />}
//           label="CGPA Schemes"
//           isDarkMode={isDarkMode}
//         />
//         <TabButton
//           active={activeTab === "sgpa"}
//           onClick={() => setActiveTab("sgpa")}
//           icon={<FaCalculator color="#8b5cf6" />}
//           label="SGPA Manager"
//           isDarkMode={isDarkMode}
//         />
//         <TabButton
//           active={activeTab === "recent-results"}
//           onClick={() => setActiveTab("recent-results")}
//           icon={<FaGlobe color="#3b82f6" />}
//           label="Recent Results"
//           isDarkMode={isDarkMode}
//         />
//         {isAdmin && (
//           <TabButton
//             active={activeTab === "muted-banned"}
//             onClick={() => setActiveTab("muted-banned")}
//             icon={<FaMicrophoneSlash color="#f59e0b" />}
//             label={`Muted/Banned (${mutedUsers.length + bannedUsers.length})`}
//             isDarkMode={isDarkMode}
//           />
//         )}
//         {isAdmin && (
//           <TabButton
//             active={activeTab === "dashboard"}
//             onClick={() => setActiveTab("dashboard")}
//             icon={<FaChartBar color="#8b5cf6" />}
//             label="Dashboard"
//             isDarkMode={isDarkMode}
//           />
//         )}
//         {isAdmin && (
//           <TabButton
//             active={activeTab === "users"}
//             onClick={() => setActiveTab("users")}
//             icon={<FaUsers color="#8b5cf6" />}
//             label="Users"
//             isDarkMode={isDarkMode}
//           />
//         )}
//         {isAdmin && (
//           <TabButton
//             active={activeTab === "result-urls"}
//             onClick={() => setActiveTab("result-urls")}
//             icon={<FaGlobe color="#3b82f6" />}
//             label="Latest Result URLs"
//             isDarkMode={isDarkMode}
//           />
//         )}
//       </div>

//       {/* Tab Content */}
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={activeTab}
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0, y: -20 }}
//           transition={{ duration: 0.3 }}
//           style={{
//             background: getCardBackgroundStatic(isDarkMode),
//             backdropFilter: "blur(20px)",
//             borderRadius: "28px",
//             padding: "1.5rem",
//             border: `1px solid ${getBorderColorStatic(isDarkMode)}`,
//             position: "relative",
//             zIndex: 1,
//           }}
//         >
//           {activeTab === "pending" && (
//             <PendingNotesTab
//               notes={pendingNotes}
//               onApprove={handleApprove}
//               onReject={(note) => {
//                 setSelectedNote(note);
//                 setShowRejectModal(true);
//               }}
//               onDelete={
//                 isAdmin
//                   ? (note) => {
//                       setSelectedNote(note);
//                       setShowDeleteModal(true);
//                     }
//                   : null
//               }
//               selectedNotes={selectedNotes}
//               setSelectedNotes={setSelectedNotes}
//               showBulkActions={showBulkActions}
//               setShowBulkActions={setShowBulkActions}
//               onBulkApprove={handleBulkApprove}
//               onBulkReject={handleBulkReject}
//               isAdmin={isAdmin}
//               isDarkMode={isDarkMode}
//             />
//           )}
//           {activeTab === "reported-notes" && (
//             <ReportedNotesTab
//               notes={reportedNotes}
//               onModerate={handleModerateNote}
//               isAdmin={isAdmin}
//               isDarkMode={isDarkMode}
//             />
//           )}
//           {activeTab === "reported-comments" && (
//             <ReportedCommentsTab
//               comments={reportedComments}
//               onModerate={handleModerateComment}
//               isAdmin={isAdmin}
//               isDarkMode={isDarkMode}
//             />
//           )}
//           {activeTab === "contacts" && (
//             <ContactsTab
//               contacts={contacts}
//               onUpdateStatus={handleUpdateContactStatus}
//               onReply={(contact) => {
//                 setSelectedContact(contact);
//                 setReplyText("");
//                 setShowReplyModal(true);
//               }}
//               onDelete={handleDeleteContact}
//               isDarkMode={isDarkMode}
//             />
//           )}
//           {activeTab === "cgpa-schemes" && <CGPASchemeManager />}
//           {activeTab === "sgpa" && <AdminSGPA />}
//           {activeTab === "recent-results" && <RecentResultsManager />}
//           {activeTab === "muted-banned" && isAdmin && (
//             <MutedBannedUsersTab
//               mutedUsers={filteredMutedUsers}
//               bannedUsers={filteredBannedUsers}
//               onUnmute={handleUnmuteUserFromAdmin}
//               onUnban={handleUnbanUserFromAdmin}
//               onRefresh={fetchMutedAndBannedUsers}
//               mutedSearchTerm={mutedSearchTerm}
//               setMutedSearchTerm={setMutedSearchTerm}
//               bannedSearchTerm={bannedSearchTerm}
//               setBannedSearchTerm={setBannedSearchTerm}
//               loading={loadingMutedBanned}
//               isDarkMode={isDarkMode}
//             />
//           )}
//           {activeTab === "dashboard" && isAdmin && dashboardData && (
//             <DashboardTab data={dashboardData} isDarkMode={isDarkMode} />
//           )}
//           {activeTab === "users" && isAdmin && (
//             <UsersTab
//               users={users}
//               onToggleStatus={handleToggleUserStatus}
//               onChangeRole={handleChangeUserRole}
//               currentAdmin={user}
//               isDarkMode={isDarkMode}
//             />
//           )}
//           {activeTab === "result-urls" && isAdmin && <ResultURLManager />}
//         </motion.div>
//       </AnimatePresence>

//       {/* Modals */}
//       {showReplyModal && selectedContact && (
//         <ReplyModal
//           selectedContact={selectedContact}
//           replyText={replyText}
//           setReplyText={setReplyText}
//           setShowReplyModal={setShowReplyModal}
//           handleReplyContact={handleReplyContact}
//           isDarkMode={isDarkMode}
//         />
//       )}
//       <RejectModal
//         isOpen={showRejectModal}
//         onClose={() => {
//           setShowRejectModal(false);
//           setRejectionReason("");
//           setSelectedNote(null);
//         }}
//         onConfirm={handleReject}
//         reason={rejectionReason}
//         setReason={setRejectionReason}
//         noteTitle={selectedNote?.title}
//         isDarkMode={isDarkMode}
//       />
//       {isAdmin && (
//         <DeleteModal
//           isOpen={showDeleteModal}
//           onClose={() => {
//             setShowDeleteModal(false);
//             setSelectedNote(null);
//           }}
//           onConfirm={handleDeleteNote}
//           noteTitle={selectedNote?.title}
//           isDarkMode={isDarkMode}
//         />
//       )}
//     </div>
//   );
// };

// // Stat Card Component
// const StatCard = ({ icon, label, value, color, isDarkMode }) => (
//   <motion.div
//     whileHover={{ y: -5, scale: 1.02 }}
//     transition={{ type: "spring", stiffness: 400, damping: 17 }}
//     style={{
//       background: getCardBackgroundStatic(isDarkMode),
//       backdropFilter: "blur(20px)",
//       padding: "1.2rem",
//       borderRadius: "20px",
//       boxShadow: isDarkMode
//         ? "0 10px 30px -8px rgba(0,0,0,0.3)"
//         : "0 10px 30px -8px rgba(0,0,0,0.1)",
//       textAlign: "center",
//       border: `1px solid ${getBorderColorStatic(isDarkMode)}`,
//       cursor: "pointer",
//     }}
//   >
//     <div style={{ fontSize: "2rem", color: color, marginBottom: "0.5rem" }}>
//       {icon}
//     </div>
//     <h3
//       style={{
//         fontSize: "1.8rem",
//         color: getTextColorStatic(isDarkMode),
//         marginBottom: "0.2rem",
//         fontWeight: "bold",
//       }}
//     >
//       {value}
//     </h3>
//     <p
//       style={{
//         color: getTextSecondaryStatic(isDarkMode),
//         fontSize: "0.8rem",
//         fontWeight: "500",
//       }}
//     >
//       {label}
//     </p>
//   </motion.div>
// );

// // Tab Button Component
// const TabButton = ({ active, onClick, icon, label, isDarkMode }) => (
//   <button
//     onClick={onClick}
//     style={{
//       padding: "0.6rem 1.2rem",
//       background: "none",
//       border: "none",
//       borderBottom: active ? "3px solid #8b5cf6" : "none",
//       color: active ? "#8b5cf6" : isDarkMode ? "#94a3b8" : "#64748b",
//       fontWeight: active ? "600" : "500",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       gap: "0.5rem",
//       fontSize: "0.85rem",
//       transition: "all 0.3s",
//     }}
//   >
//     {icon} {label}
//   </button>
// );

// // Helper functions
// const getCardBackgroundStatic = (isDarkMode) =>
//   isDarkMode ? "rgba(30, 30, 45, 0.8)" : "rgba(255, 255, 255, 0.9)";
// const getTextColorStatic = (isDarkMode) => (isDarkMode ? "#f1f5f9" : "#1e293b");
// const getTextSecondaryStatic = (isDarkMode) =>
//   isDarkMode ? "#94a3b8" : "#64748b";
// const getBorderColorStatic = (isDarkMode) =>
//   isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
// const getInputBackgroundStatic = (isDarkMode) =>
//   isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff";

// // Helper function for avatar
// const getAvatarDataUrl = (name, size = 40) => {
//   const initials =
//     name
//       ?.split(" ")
//       .map((n) => n[0])
//       .join("")
//       .toUpperCase()
//       .substring(0, 2) || "U";
//   const fontSize = size * 0.45;
//   const yPos = size * 0.65;
//   return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 ${size} ${size}'%3E%3Crect width='${size}' height='${size}' fill='%238b5cf6'/%3E%3Ctext x='${size / 2}' y='${yPos}' font-size='${fontSize}' text-anchor='middle' fill='white' font-family='Arial'%3E${initials}%3C/text%3E%3C/svg%3E`;
// };

// // Contacts Tab Component - FIXED: Removed borderLeft and border conflict
// const ContactsTab = ({
//   contacts,
//   onUpdateStatus,
//   onReply,
//   onDelete,
//   isDarkMode,
// }) => {
//   const [filter, setFilter] = useState("all");
//   const [search, setSearch] = useState("");

//   const getStatusBadge = (status) => {
//     const statuses = {
//       pending: { label: "Pending", color: "#f59e0b", icon: <FaClock /> },
//       read: { label: "Read", color: "#06b6d4", icon: <FaEye /> },
//       replied: { label: "Replied", color: "#10b981", icon: <FaReply /> },
//       resolved: { label: "Resolved", color: "#6c757d", icon: <FaCheck /> },
//     };
//     const s = statuses[status] || statuses.pending;
//     return (
//       <span
//         style={{
//           background: s.color,
//           color: "white",
//           padding: "0.2rem 0.6rem",
//           borderRadius: "20px",
//           fontSize: "0.7rem",
//           display: "inline-flex",
//           alignItems: "center",
//           gap: "0.3rem",
//         }}
//       >
//         {s.icon} {s.label}
//       </span>
//     );
//   };

//   const filteredContacts = contacts.filter((contact) => {
//     if (filter !== "all" && contact.status !== filter) return false;
//     if (
//       search &&
//       !contact.name.toLowerCase().includes(search.toLowerCase()) &&
//       !contact.email.toLowerCase().includes(search.toLowerCase())
//     )
//       return false;
//     return true;
//   });

//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   // Get border left color based on status
//   const getBorderLeftColor = (status) => {
//     switch (status) {
//       case "pending":
//         return "#f59e0b";
//       case "read":
//         return "#06b6d4";
//       case "replied":
//         return "#10b981";
//       case "resolved":
//         return "#6c757d";
//       default:
//         return "#f59e0b";
//     }
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           gap: "1rem",
//           marginBottom: "1.5rem",
//           flexWrap: "wrap",
//         }}
//       >
//         <select
//           value={filter}
//           onChange={(e) => setFilter(e.target.value)}
//           style={{
//             padding: "0.5rem 1rem",
//             border: `2px solid ${getBorderColor()}`,
//             borderRadius: "12px",
//             outline: "none",
//             background: getInputBackgroundStatic(isDarkMode),
//             color: getTextColor(),
//           }}
//         >
//           <option value="all">All Messages</option>
//           <option value="pending">Pending</option>
//           <option value="read">Read</option>
//           <option value="replied">Replied</option>
//           <option value="resolved">Resolved</option>
//         </select>
//         <input
//           type="text"
//           placeholder="Search by name or email..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           style={{
//             flex: 1,
//             padding: "0.5rem 1rem",
//             border: `2px solid ${getBorderColor()}`,
//             borderRadius: "12px",
//             outline: "none",
//             background: getInputBackgroundStatic(isDarkMode),
//             color: getTextColor(),
//           }}
//         />
//       </div>
//       {filteredContacts.length === 0 ? (
//         <div
//           style={{
//             textAlign: "center",
//             padding: "3rem",
//             background: getBgColor(),
//             borderRadius: "20px",
//             border: `1px solid ${getBorderColor()}`,
//           }}
//         >
//           <FaEnvelope size={50} color={getTextSecondaryStatic(isDarkMode)} />
//           <h3 style={{ margin: "1rem 0", color: getTextColor() }}>
//             No Messages
//           </h3>
//           <p style={{ color: getTextSecondaryStatic(isDarkMode) }}>
//             No contact messages found.
//           </p>
//         </div>
//       ) : (
//         <div style={{ display: "grid", gap: "1rem" }}>
//           {filteredContacts.map((contact) => (
//             <motion.div
//               key={contact._id}
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               style={{
//                 background: getBgColor(),
//                 padding: "1rem",
//                 borderRadius: "16px",
//                 boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//                 borderLeftWidth: "4px",
//                 borderLeftStyle: "solid",
//                 borderLeftColor: getBorderLeftColor(contact.status),
//                 borderTop: `1px solid ${getBorderColor()}`,
//                 borderRight: `1px solid ${getBorderColor()}`,
//                 borderBottom: `1px solid ${getBorderColor()}`,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "flex-start",
//                   flexWrap: "wrap",
//                   gap: "1rem",
//                 }}
//               >
//                 <div style={{ flex: 1 }}>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.8rem",
//                       flexWrap: "wrap",
//                       marginBottom: "0.5rem",
//                     }}
//                   >
//                     <h3 style={{ margin: 0, color: getTextColor() }}>
//                       {contact.name}
//                     </h3>
//                     <span
//                       style={{
//                         color: getTextSecondaryStatic(isDarkMode),
//                         fontSize: "0.8rem",
//                       }}
//                     >
//                       {contact.email}
//                     </span>
//                     {getStatusBadge(contact.status)}
//                   </div>
//                   <p
//                     style={{
//                       color: getTextColor(),
//                       marginBottom: "0.3rem",
//                       fontWeight: "500",
//                     }}
//                   >
//                     {contact.subject}
//                   </p>
//                   <p
//                     style={{
//                       color: getTextSecondaryStatic(isDarkMode),
//                       fontSize: "0.85rem",
//                       marginBottom: "0.5rem",
//                     }}
//                   >
//                     {contact.message.substring(0, 100)}...
//                   </p>
//                   <p
//                     style={{
//                       color: getTextSecondaryStatic(isDarkMode),
//                       fontSize: "0.7rem",
//                     }}
//                   >
//                     Received: {new Date(contact.createdAt).toLocaleString()}
//                   </p>
//                 </div>
//                 <div style={{ display: "flex", gap: "0.5rem" }}>
//                   <button
//                     onClick={() =>
//                       window.open(`mailto:${contact.email}`, "_blank")
//                     }
//                     style={{
//                       padding: "0.4rem 0.8rem",
//                       background: "#06b6d4",
//                       color: "white",
//                       border: "none",
//                       borderRadius: "8px",
//                       cursor: "pointer",
//                     }}
//                     title="Email"
//                   >
//                     <FaEnvelope />
//                   </button>
//                   <button
//                     onClick={() => onReply(contact)}
//                     style={{
//                       padding: "0.4rem 0.8rem",
//                       background: "#10b981",
//                       color: "white",
//                       border: "none",
//                       borderRadius: "8px",
//                       cursor: "pointer",
//                     }}
//                     title="Reply"
//                   >
//                     <FaReply />
//                   </button>
//                   {contact.status !== "resolved" &&
//                     contact.status !== "replied" && (
//                       <button
//                         onClick={() => onUpdateStatus(contact._id, "resolved")}
//                         style={{
//                           padding: "0.4rem 0.8rem",
//                           background: "#6c757d",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "8px",
//                           cursor: "pointer",
//                         }}
//                         title="Mark Resolved"
//                       >
//                         <FaCheck />
//                       </button>
//                     )}
//                   <button
//                     onClick={() => onDelete(contact._id)}
//                     style={{
//                       padding: "0.4rem 0.8rem",
//                       background: "#ef4444",
//                       color: "white",
//                       border: "none",
//                       borderRadius: "8px",
//                       cursor: "pointer",
//                     }}
//                     title="Delete"
//                   >
//                     <FaTrash />
//                   </button>
//                 </div>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// // Dashboard Tab Component
// const DashboardTab = ({ data, isDarkMode }) => {
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);
//   const getAvatar = (name) => getAvatarDataUrl(name, 40);

//   return (
//     <div
//       style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem" }}
//     >
//       <div
//         style={{
//           background: getBgColor(),
//           padding: "1.5rem",
//           borderRadius: "20px",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//       >
//         <h3
//           style={{
//             color: getTextColor(),
//             marginBottom: "1rem",
//             display: "flex",
//             alignItems: "center",
//             gap: "0.5rem",
//           }}
//         >
//           <FaUsers color="#8b5cf6" /> Recent Users
//         </h3>
//         {data.recentUsers.map((user) => (
//           <div
//             key={user._id}
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               padding: "0.8rem 0",
//               borderBottom: `1px solid ${getBorderColor()}`,
//             }}
//           >
//             <div>
//               <div style={{ fontWeight: "500", color: getTextColor() }}>
//                 {user.name}
//               </div>
//               <div
//                 style={{
//                   fontSize: "0.85rem",
//                   color: getTextSecondaryStatic(isDarkMode),
//                 }}
//               >
//                 {user.email}
//               </div>
//             </div>
//             <div
//               style={{
//                 fontSize: "0.85rem",
//                 color: getTextSecondaryStatic(isDarkMode),
//               }}
//             >
//               {new Date(user.createdAt).toLocaleDateString()}
//             </div>
//           </div>
//         ))}
//       </div>
//       <div
//         style={{
//           background: getBgColor(),
//           padding: "1.5rem",
//           borderRadius: "20px",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//       >
//         <h3
//           style={{
//             color: getTextColor(),
//             marginBottom: "1rem",
//             display: "flex",
//             alignItems: "center",
//             gap: "0.5rem",
//           }}
//         >
//           <FaTrophy color="#f59e0b" /> Top Contributors
//         </h3>
//         {data.topContributors.map((user) => (
//           <div
//             key={user._id}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "1rem",
//               padding: "0.8rem 0",
//               borderBottom: `1px solid ${getBorderColor()}`,
//             }}
//           >
//             <img
//               src={user.profilePicture || getAvatar(user.name)}
//               alt={user.name}
//               style={{ width: "40px", height: "40px", borderRadius: "50%" }}
//             />
//             <div style={{ flex: 1 }}>
//               <div style={{ fontWeight: "500", color: getTextColor() }}>
//                 {user.name}
//               </div>
//               <div
//                 style={{
//                   fontSize: "0.85rem",
//                   color: getTextSecondaryStatic(isDarkMode),
//                 }}
//               >
//                 {user.contributions.notesUploaded} notes uploaded
//               </div>
//             </div>
//             <FaStar color="#f59e0b" />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// // Pending Notes Tab Component
// const PendingNotesTab = ({
//   notes,
//   onApprove,
//   onReject,
//   onDelete,
//   selectedNotes,
//   setSelectedNotes,
//   showBulkActions,
//   setShowBulkActions,
//   onBulkApprove,
//   onBulkReject,
//   isAdmin,
//   isDarkMode,
// }) => {
//   const toggleSelectNote = (noteId) => {
//     if (selectedNotes.includes(noteId))
//       setSelectedNotes(selectedNotes.filter((id) => id !== noteId));
//     else setSelectedNotes([...selectedNotes, noteId]);
//   };
//   const toggleSelectAll = () => {
//     if (selectedNotes.length === notes.length) setSelectedNotes([]);
//     else setSelectedNotes(notes.map((n) => n._id));
//   };
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   if (notes.length === 0) {
//     return (
//       <div
//         style={{
//           textAlign: "center",
//           padding: "3rem",
//           background: getBgColor(),
//           borderRadius: "20px",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//       >
//         <FaCheckCircle size={50} color="#10b981" />
//         <h3 style={{ margin: "1rem 0", color: getTextColor() }}>
//           All Caught Up!
//         </h3>
//         <p style={{ color: getTextSecondaryStatic(isDarkMode) }}>
//           No pending notes to review
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       {notes.length > 0 && (
//         <div
//           style={{
//             background: isDarkMode ? "rgba(139,92,246,0.1)" : "#f8f9fa",
//             padding: "1rem",
//             borderRadius: "12px",
//             marginBottom: "1rem",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: "1rem",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
//             <label
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "0.5rem",
//                 color: getTextColor(),
//               }}
//             >
//               <input
//                 type="checkbox"
//                 checked={selectedNotes.length === notes.length}
//                 onChange={toggleSelectAll}
//               />{" "}
//               <span>Select All ({selectedNotes.length} selected)</span>
//             </label>
//             {selectedNotes.length > 0 && (
//               <div style={{ display: "flex", gap: "0.5rem" }}>
//                 <button
//                   onClick={onBulkApprove}
//                   style={{
//                     padding: "0.3rem 1rem",
//                     background: "#10b981",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Approve Selected
//                 </button>
//                 <button
//                   onClick={onBulkReject}
//                   style={{
//                     padding: "0.3rem 1rem",
//                     background: "#ef4444",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Reject Selected
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//       <div style={{ display: "grid", gap: "1rem" }}>
//         {notes.map((note) => (
//           <PendingNoteCard
//             key={note._id}
//             note={note}
//             onApprove={() => onApprove(note._id)}
//             onReject={() => onReject(note)}
//             onDelete={() => onDelete && onDelete(note)}
//             isSelected={selectedNotes.includes(note._id)}
//             onSelect={() => toggleSelectNote(note._id)}
//             isAdmin={isAdmin}
//             isDarkMode={isDarkMode}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// // Pending Note Card Component
// const PendingNoteCard = ({
//   note,
//   onApprove,
//   onReject,
//   onDelete,
//   isSelected,
//   onSelect,
//   isAdmin,
//   isDarkMode,
// }) => {
//   const getFileIcon = (type) => {
//     if (type?.includes("pdf")) return <FaFilePdf color="#ef4444" />;
//     if (type?.includes("doc")) return <FaFileWord color="#3b82f6" />;
//     if (type?.includes("ppt")) return <FaFilePowerpoint color="#f59e0b" />;
//     return <FaFileAlt color="#8b5cf6" />;
//   };
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       style={{
//         background: getBgColor(),
//         padding: "1rem",
//         borderRadius: "16px",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//         border: `1px solid #f59e0b`,
//         position: "relative",
//       }}
//     >
//       <div style={{ display: "flex", alignItems: "start", gap: "1rem" }}>
//         <input
//           type="checkbox"
//           checked={isSelected}
//           onChange={onSelect}
//           style={{ marginTop: "0.3rem" }}
//         />
//         <div style={{ fontSize: "1.5rem" }}>{getFileIcon(note.fileType)}</div>
//         <div style={{ flex: 1 }}>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "start",
//               flexWrap: "wrap",
//               gap: "1rem",
//             }}
//           >
//             <div>
//               <h3 style={{ color: getTextColor(), marginBottom: "0.5rem" }}>
//                 {note.title}
//               </h3>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "0.5rem",
//                   flexWrap: "wrap",
//                   marginBottom: "0.5rem",
//                 }}
//               >
//                 <span
//                   style={{
//                     background: "#8b5cf6",
//                     color: "white",
//                     padding: "0.2rem 0.5rem",
//                     borderRadius: "5px",
//                     fontSize: "0.8rem",
//                   }}
//                 >
//                   {note.subjectCode}
//                 </span>
//                 <span
//                   style={{
//                     background: isDarkMode ? "#25253a" : "#f0f0f0",
//                     color: getTextSecondaryStatic(isDarkMode),
//                     padding: "0.2rem 0.5rem",
//                     borderRadius: "5px",
//                     fontSize: "0.8rem",
//                   }}
//                 >
//                   {note.branch} - Sem {note.semester}
//                 </span>
//                 {note.module && (
//                   <span
//                     style={{
//                       background: isDarkMode ? "#25253a" : "#f0f0f0",
//                       color: getTextSecondaryStatic(isDarkMode),
//                       padding: "0.2rem 0.5rem",
//                       borderRadius: "5px",
//                       fontSize: "0.8rem",
//                     }}
//                   >
//                     Module {note.module}
//                   </span>
//                 )}
//               </div>
//               <p
//                 style={{
//                   color: getTextSecondaryStatic(isDarkMode),
//                   marginBottom: "0.5rem",
//                   fontSize: "0.85rem",
//                 }}
//               >
//                 <strong>Uploaded by:</strong> {note.uploadedBy?.name} (
//                 {note.uploadedBy?.email})
//               </p>
//               <p
//                 style={{
//                   color: getTextSecondaryStatic(isDarkMode),
//                   marginBottom: "0.5rem",
//                   fontSize: "0.85rem",
//                 }}
//               >
//                 <strong>USN:</strong> {note.uploadedBy?.usn}
//               </p>
//               <p
//                 style={{
//                   color: getTextSecondaryStatic(isDarkMode),
//                   fontSize: "0.8rem",
//                 }}
//               >
//                 Uploaded: {new Date(note.createdAt).toLocaleString()}
//               </p>
//             </div>
//             <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
//               <button
//                 onClick={() => window.open(`/notes/${note._id}`, "_blank")}
//                 style={{
//                   padding: "0.4rem 0.8rem",
//                   background: "#06b6d4",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "0.3rem",
//                 }}
//               >
//                 <FaEye /> View
//               </button>
//               <button
//                 onClick={onApprove}
//                 style={{
//                   padding: "0.4rem 0.8rem",
//                   background: "#10b981",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "0.3rem",
//                 }}
//               >
//                 <FaCheck /> Approve
//               </button>
//               <button
//                 onClick={onReject}
//                 style={{
//                   padding: "0.4rem 0.8rem",
//                   background: "#f59e0b",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "0.3rem",
//                 }}
//               >
//                 <FaTimes /> Reject
//               </button>
//               {isAdmin && (
//                 <button
//                   onClick={onDelete}
//                   style={{
//                     padding: "0.4rem 0.8rem",
//                     background: "#ef4444",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "0.3rem",
//                   }}
//                 >
//                   <FaTrash /> Delete
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </motion.div>
//   );
// };

// // Reported Notes Tab Component
// const ReportedNotesTab = ({ notes, onModerate, isAdmin, isDarkMode }) => {
//   const [selectedNote, setSelectedNote] = useState(null);
//   const [showModerateModal, setShowModerateModal] = useState(false);
//   const [moderationAction, setModerationAction] = useState("");
//   const [moderationNote, setModerationNote] = useState("");
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   const handleModerate = () => {
//     if (!moderationAction) {
//       toast.error("Please select an action");
//       return;
//     }
//     onModerate(selectedNote._id, moderationAction, moderationNote);
//     setShowModerateModal(false);
//     setSelectedNote(null);
//     setModerationAction("");
//     setModerationNote("");
//   };

//   const getReportReasons = (note) => {
//     const reasons = note.reports?.map((r) => r.reason) || [];
//     return [...new Set(reasons)].join(", ");
//   };

//   if (notes.length === 0) {
//     return (
//       <div
//         style={{
//           textAlign: "center",
//           padding: "3rem",
//           background: getBgColor(),
//           borderRadius: "20px",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//       >
//         <FaCheckCircle size={50} color="#10b981" />
//         <h3 style={{ margin: "1rem 0", color: getTextColor() }}>
//           No Reported Notes
//         </h3>
//         <p style={{ color: getTextSecondaryStatic(isDarkMode) }}>
//           All notes are clean! No reports to review.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div style={{ display: "grid", gap: "1rem" }}>
//         {notes.map((note) => (
//           <ReportedNoteCard
//             key={note._id}
//             note={note}
//             onModerate={() => {
//               setSelectedNote(note);
//               setShowModerateModal(true);
//             }}
//             reportReasons={getReportReasons(note)}
//             isAdmin={isAdmin}
//             isDarkMode={isDarkMode}
//           />
//         ))}
//       </div>
//       {showModerateModal && selectedNote && (
//         <ModerateModal
//           title="Moderate Note"
//           item={selectedNote}
//           action={moderationAction}
//           setAction={setModerationAction}
//           note={moderationNote}
//           setNote={setModerationNote}
//           onConfirm={handleModerate}
//           onClose={() => {
//             setShowModerateModal(false);
//             setSelectedNote(null);
//           }}
//           isAdmin={isAdmin}
//           isDarkMode={isDarkMode}
//         />
//       )}
//     </div>
//   );
// };

// // Reported Note Card Component
// const ReportedNoteCard = ({
//   note,
//   onModerate,
//   reportReasons,
//   isAdmin,
//   isDarkMode,
// }) => {
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       style={{
//         background: getBgColor(),
//         padding: "1rem",
//         borderRadius: "16px",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//         borderLeft: "4px solid #ef4444",
//         borderTop: `1px solid ${getBorderColor()}`,
//         borderRight: `1px solid ${getBorderColor()}`,
//         borderBottom: `1px solid ${getBorderColor()}`,
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "start",
//           flexWrap: "wrap",
//           gap: "1rem",
//         }}
//       >
//         <div style={{ flex: 1 }}>
//           <h3 style={{ color: getTextColor(), marginBottom: "0.5rem" }}>
//             {note.title}
//           </h3>
//           <div
//             style={{
//               display: "flex",
//               gap: "0.5rem",
//               flexWrap: "wrap",
//               marginBottom: "0.5rem",
//             }}
//           >
//             <span
//               style={{
//                 background: "#8b5cf6",
//                 color: "white",
//                 padding: "0.2rem 0.5rem",
//                 borderRadius: "5px",
//                 fontSize: "0.8rem",
//               }}
//             >
//               {note.subjectCode}
//             </span>
//             <span
//               style={{
//                 background: isDarkMode ? "#25253a" : "#f0f0f0",
//                 color: getTextSecondaryStatic(isDarkMode),
//                 padding: "0.2rem 0.5rem",
//                 borderRadius: "5px",
//                 fontSize: "0.8rem",
//               }}
//             >
//               {note.branch} - Sem {note.semester}
//             </span>
//           </div>
//           <p
//             style={{
//               color: getTextSecondaryStatic(isDarkMode),
//               marginBottom: "0.5rem",
//               fontSize: "0.9rem",
//             }}
//           >
//             {note.description?.substring(0, 200)}...
//           </p>
//           <div
//             style={{
//               display: "flex",
//               gap: "1rem",
//               flexWrap: "wrap",
//               marginBottom: "0.5rem",
//             }}
//           >
//             <span
//               style={{
//                 background: isDarkMode ? "#25253a" : "#f8f9fa",
//                 padding: "0.2rem 0.5rem",
//                 borderRadius: "5px",
//                 fontSize: "0.8rem",
//                 color: getTextSecondaryStatic(isDarkMode),
//               }}
//             >
//               <FaFlag color="#ef4444" /> Reported by {note.reports?.length || 0}{" "}
//               users
//             </span>
//             <span
//               style={{
//                 background: isDarkMode ? "#25253a" : "#f8f9fa",
//                 padding: "0.2rem 0.5rem",
//                 borderRadius: "5px",
//                 fontSize: "0.8rem",
//                 color: getTextSecondaryStatic(isDarkMode),
//               }}
//             >
//               Reason: {reportReasons}
//             </span>
//           </div>
//           <div
//             style={{
//               fontSize: "0.8rem",
//               color: getTextSecondaryStatic(isDarkMode),
//             }}
//           >
//             Uploaded by: {note.uploadedBy?.name} ({note.uploadedBy?.email})
//           </div>
//         </div>
//         <div style={{ display: "flex", gap: "0.5rem" }}>
//           <button
//             onClick={() => window.open(`/notes/${note._id}`, "_blank")}
//             style={{
//               padding: "0.4rem 0.8rem",
//               background: "#06b6d4",
//               color: "white",
//               border: "none",
//               borderRadius: "8px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               gap: "0.3rem",
//             }}
//           >
//             <FaEye /> View
//           </button>
//           <button
//             onClick={onModerate}
//             style={{
//               padding: "0.4rem 0.8rem",
//               background: "#8b5cf6",
//               color: "white",
//               border: "none",
//               borderRadius: "8px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               gap: "0.3rem",
//             }}
//           >
//             <FaEdit /> Moderate
//           </button>
//         </div>
//       </div>
//     </motion.div>
//   );
// };

// // Reported Comments Tab Component
// const ReportedCommentsTab = ({ comments, onModerate, isAdmin, isDarkMode }) => {
//   const [selectedComment, setSelectedComment] = useState(null);
//   const [showModerateModal, setShowModerateModal] = useState(false);
//   const [moderationAction, setModerationAction] = useState("");
//   const [moderationNote, setModerationNote] = useState("");
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   const handleModerate = () => {
//     if (!moderationAction) {
//       toast.error("Please select an action");
//       return;
//     }
//     onModerate(selectedComment._id, moderationAction, moderationNote);
//     setShowModerateModal(false);
//     setSelectedComment(null);
//     setModerationAction("");
//     setModerationNote("");
//   };

//   const getReportReasons = (comment) => {
//     const reasons = comment.reports?.map((r) => r.reason) || [];
//     return [...new Set(reasons)].join(", ");
//   };

//   if (comments.length === 0) {
//     return (
//       <div
//         style={{
//           textAlign: "center",
//           padding: "3rem",
//           background: getBgColor(),
//           borderRadius: "20px",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//       >
//         <FaCheckCircle size={50} color="#10b981" />
//         <h3 style={{ margin: "1rem 0", color: getTextColor() }}>
//           No Reported Comments
//         </h3>
//         <p style={{ color: getTextSecondaryStatic(isDarkMode) }}>
//           All comments are clean! No reports to review.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div style={{ display: "grid", gap: "1rem" }}>
//         {comments.map((comment) => (
//           <ReportedCommentCard
//             key={comment._id}
//             comment={comment}
//             onModerate={() => {
//               setSelectedComment(comment);
//               setShowModerateModal(true);
//             }}
//             reportReasons={getReportReasons(comment)}
//             isAdmin={isAdmin}
//             isDarkMode={isDarkMode}
//           />
//         ))}
//       </div>
//       {showModerateModal && selectedComment && (
//         <ModerateModal
//           title="Moderate Comment"
//           item={selectedComment}
//           action={moderationAction}
//           setAction={setModerationAction}
//           note={moderationNote}
//           setNote={setModerationNote}
//           onConfirm={handleModerate}
//           onClose={() => {
//             setShowModerateModal(false);
//             setSelectedComment(null);
//           }}
//           isAdmin={isAdmin}
//           isDarkMode={isDarkMode}
//         />
//       )}
//     </div>
//   );
// };

// // Reported Comment Card Component
// const ReportedCommentCard = ({
//   comment,
//   onModerate,
//   reportReasons,
//   isAdmin,
//   isDarkMode,
// }) => {
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);
//   const getAvatar = (name) => getAvatarDataUrl(name, 40);

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       style={{
//         background: getBgColor(),
//         padding: "1rem",
//         borderRadius: "16px",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//         borderLeft: "4px solid #ef4444",
//         borderTop: `1px solid ${getBorderColor()}`,
//         borderRight: `1px solid ${getBorderColor()}`,
//         borderBottom: `1px solid ${getBorderColor()}`,
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "start",
//           flexWrap: "wrap",
//           gap: "1rem",
//         }}
//       >
//         <div style={{ flex: 1 }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "0.8rem",
//               marginBottom: "0.5rem",
//             }}
//           >
//             <img
//               src={
//                 comment.user?.profilePicture || getAvatar(comment.user?.name)
//               }
//               alt={comment.user?.name}
//               style={{ width: "40px", height: "40px", borderRadius: "50%" }}
//             />
//             <div>
//               <strong style={{ color: getTextColor() }}>
//                 {comment.user?.name}
//               </strong>
//               <span
//                 style={{
//                   color: getTextSecondaryStatic(isDarkMode),
//                   fontSize: "0.8rem",
//                   marginLeft: "0.5rem",
//                 }}
//               >
//                 {new Date(comment.createdAt).toLocaleString()}
//               </span>
//             </div>
//           </div>
//           <p
//             style={{
//               color: getTextColor(),
//               marginBottom: "0.5rem",
//               lineHeight: "1.5",
//             }}
//           >
//             {comment.content}
//           </p>
//           <div
//             style={{
//               display: "flex",
//               gap: "1rem",
//               flexWrap: "wrap",
//               marginBottom: "0.5rem",
//             }}
//           >
//             <span
//               style={{
//                 background: isDarkMode ? "#25253a" : "#f8f9fa",
//                 padding: "0.2rem 0.5rem",
//                 borderRadius: "5px",
//                 fontSize: "0.8rem",
//                 color: getTextSecondaryStatic(isDarkMode),
//               }}
//             >
//               <FaFlag color="#ef4444" /> Reported by{" "}
//               {comment.reports?.length || 0} users
//             </span>
//             <span
//               style={{
//                 background: isDarkMode ? "#25253a" : "#f8f9fa",
//                 padding: "0.2rem 0.5rem",
//                 borderRadius: "5px",
//                 fontSize: "0.8rem",
//                 color: getTextSecondaryStatic(isDarkMode),
//               }}
//             >
//               Reason: {reportReasons}
//             </span>
//           </div>
//           <div
//             style={{
//               fontSize: "0.8rem",
//               color: getTextSecondaryStatic(isDarkMode),
//             }}
//           >
//             Note:{" "}
//             <Link
//               to={`/notes/${comment.note?._id}`}
//               style={{ color: "#8b5cf6" }}
//             >
//               {comment.note?.title}
//             </Link>
//           </div>
//         </div>
//         <button
//           onClick={onModerate}
//           style={{
//             padding: "0.4rem 0.8rem",
//             background: "#8b5cf6",
//             color: "white",
//             border: "none",
//             borderRadius: "8px",
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             gap: "0.3rem",
//           }}
//         >
//           <FaEdit /> Moderate
//         </button>
//       </div>
//     </motion.div>
//   );
// };

// // Users Tab Component
// const UsersTab = ({
//   users,
//   onToggleStatus,
//   onChangeRole,
//   currentAdmin,
//   isDarkMode,
// }) => {
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);
//   const getAvatar = (name) => getAvatarDataUrl(name, 30);

//   return (
//     <div
//       style={{
//         background: getBgColor(),
//         borderRadius: "20px",
//         overflow: "auto",
//         border: `1px solid ${getBorderColor()}`,
//       }}
//     >
//       <table
//         style={{ width: "100%", borderCollapse: "collapse", minWidth: "800px" }}
//       >
//         <thead>
//           <tr
//             style={{
//               background: isDarkMode ? "rgba(139,92,246,0.1)" : "#f8f9fa",
//               borderBottom: `2px solid ${getBorderColor()}`,
//             }}
//           >
//             <th
//               style={{
//                 padding: "0.8rem",
//                 textAlign: "left",
//                 color: getTextColor(),
//               }}
//             >
//               User
//             </th>
//             <th
//               style={{
//                 padding: "0.8rem",
//                 textAlign: "left",
//                 color: getTextColor(),
//               }}
//             >
//               Email
//             </th>
//             <th
//               style={{
//                 padding: "0.8rem",
//                 textAlign: "left",
//                 color: getTextColor(),
//               }}
//             >
//               USN
//             </th>
//             <th
//               style={{
//                 padding: "0.8rem",
//                 textAlign: "left",
//                 color: getTextColor(),
//               }}
//             >
//               Branch
//             </th>
//             <th
//               style={{
//                 padding: "0.8rem",
//                 textAlign: "left",
//                 color: getTextColor(),
//               }}
//             >
//               Semester
//             </th>
//             <th
//               style={{
//                 padding: "0.8rem",
//                 textAlign: "left",
//                 color: getTextColor(),
//               }}
//             >
//               Role
//             </th>
//             <th
//               style={{
//                 padding: "0.8rem",
//                 textAlign: "left",
//                 color: getTextColor(),
//               }}
//             >
//               Status
//             </th>
//             <th
//               style={{
//                 padding: "0.8rem",
//                 textAlign: "left",
//                 color: getTextColor(),
//               }}
//             >
//               Actions
//             </th>
//           </tr>
//         </thead>
//         <tbody>
//           {users.map((user) => (
//             <tr
//               key={user._id}
//               style={{ borderBottom: `1px solid ${getBorderColor()}` }}
//             >
//               <td style={{ padding: "0.8rem" }}>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "0.5rem",
//                   }}
//                 >
//                   <img
//                     src={user.profilePicture || getAvatar(user.name)}
//                     alt={user.name}
//                     style={{
//                       width: "30px",
//                       height: "30px",
//                       borderRadius: "50%",
//                     }}
//                   />
//                   {user.name}
//                 </div>
//               </td>
//               <td style={{ padding: "0.8rem", color: getTextColor() }}>
//                 {user.email}
//               </td>
//               <td style={{ padding: "0.8rem", color: getTextColor() }}>
//                 {user.usn}
//               </td>
//               <td style={{ padding: "0.8rem", color: getTextColor() }}>
//                 {user.branch}
//               </td>
//               <td style={{ padding: "0.8rem", color: getTextColor() }}>
//                 {user.semester}
//               </td>
//               <td style={{ padding: "0.8rem" }}>
//                 <select
//                   value={user.role}
//                   onChange={(e) => onChangeRole(user._id, e.target.value)}
//                   disabled={user._id === currentAdmin?._id}
//                   style={{
//                     padding: "0.3rem",
//                     borderRadius: "8px",
//                     border: `1px solid ${getBorderColor()}`,
//                     background: getInputBackgroundStatic(isDarkMode),
//                     color: getTextColor(),
//                   }}
//                 >
//                   <option value="user">User</option>
//                   <option value="moderator">Moderator</option>
//                   <option value="admin">Admin</option>
//                 </select>
//               </td>
//               <td style={{ padding: "0.8rem" }}>
//                 <span
//                   style={{
//                     padding: "0.2rem 0.6rem",
//                     borderRadius: "20px",
//                     background: user.isActive ? "#10b981" : "#ef4444",
//                     color: "white",
//                     fontSize: "0.75rem",
//                   }}
//                 >
//                   {user.isActive ? "Active" : "Inactive"}
//                 </span>
//               </td>
//               <td style={{ padding: "0.8rem" }}>
//                 <button
//                   onClick={() => onToggleStatus(user._id)}
//                   disabled={user._id === currentAdmin?._id}
//                   style={{
//                     padding: "0.3rem 0.8rem",
//                     background: user.isActive ? "#ef4444" : "#10b981",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "8px",
//                     cursor:
//                       user._id === currentAdmin?._id
//                         ? "not-allowed"
//                         : "pointer",
//                     opacity: user._id === currentAdmin?._id ? 0.5 : 1,
//                   }}
//                 >
//                   {user.isActive ? "Deactivate" : "Activate"}
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// // Muted/Banned Users Tab Component
// const MutedBannedUsersTab = ({
//   mutedUsers,
//   bannedUsers,
//   onUnmute,
//   onUnban,
//   onRefresh,
//   mutedSearchTerm,
//   setMutedSearchTerm,
//   bannedSearchTerm,
//   setBannedSearchTerm,
//   loading,
//   isDarkMode,
// }) => {
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   if (loading)
//     return (
//       <div style={{ textAlign: "center", padding: "3rem" }}>
//         <FaSpinner
//           style={{
//             animation: "spin 1s linear infinite",
//             fontSize: "2rem",
//             color: "#8b5cf6",
//           }}
//         />
//       </div>
//     );

//   return (
//     <div>
//       <div style={{ marginBottom: "2rem" }}>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: "1rem",
//             marginBottom: "1rem",
//           }}
//         >
//           <h2
//             style={{
//               color: "#f59e0b",
//               display: "flex",
//               alignItems: "center",
//               gap: "0.5rem",
//             }}
//           >
//             <FaMicrophoneSlash /> Muted Users ({mutedUsers.length})
//           </h2>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "0.5rem",
//               background: getBgColor(),
//               padding: "0.3rem 0.8rem",
//               borderRadius: "20px",
//               border: `1px solid ${getBorderColor()}`,
//             }}
//           >
//             <FaSearch size={12} color={getTextSecondaryStatic(isDarkMode)} />
//             <input
//               type="text"
//               placeholder="Search muted users..."
//               value={mutedSearchTerm}
//               onChange={(e) => setMutedSearchTerm(e.target.value)}
//               style={{
//                 border: "none",
//                 background: "none",
//                 outline: "none",
//                 fontSize: "0.85rem",
//                 width: "200px",
//                 color: getTextColor(),
//               }}
//             />
//           </div>
//         </div>
//         {mutedUsers.length === 0 ? (
//           <div
//             style={{
//               textAlign: "center",
//               padding: "2rem",
//               background: getBgColor(),
//               borderRadius: "16px",
//               border: `1px solid ${getBorderColor()}`,
//               color: getTextSecondaryStatic(isDarkMode),
//             }}
//           >
//             No muted users found
//           </div>
//         ) : (
//           <div
//             style={{
//               display: "grid",
//               gap: "1rem",
//               gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
//             }}
//           >
//             {mutedUsers.map((user) => (
//               <MutedBannedUserCard
//                 key={user._id}
//                 user={user}
//                 type="muted"
//                 onAction={onUnmute}
//                 actionIcon={<FaMicrophone />}
//                 actionLabel="Unmute"
//                 actionColor="#10b981"
//                 isDarkMode={isDarkMode}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//       <div>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: "1rem",
//             marginBottom: "1rem",
//           }}
//         >
//           <h2
//             style={{
//               color: "#ef4444",
//               display: "flex",
//               alignItems: "center",
//               gap: "0.5rem",
//             }}
//           >
//             <FaBan /> Banned Users ({bannedUsers.length})
//           </h2>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "0.5rem",
//               background: getBgColor(),
//               padding: "0.3rem 0.8rem",
//               borderRadius: "20px",
//               border: `1px solid ${getBorderColor()}`,
//             }}
//           >
//             <FaSearch size={12} color={getTextSecondaryStatic(isDarkMode)} />
//             <input
//               type="text"
//               placeholder="Search banned users..."
//               value={bannedSearchTerm}
//               onChange={(e) => setBannedSearchTerm(e.target.value)}
//               style={{
//                 border: "none",
//                 background: "none",
//                 outline: "none",
//                 fontSize: "0.85rem",
//                 width: "200px",
//                 color: getTextColor(),
//               }}
//             />
//           </div>
//         </div>
//         {bannedUsers.length === 0 ? (
//           <div
//             style={{
//               textAlign: "center",
//               padding: "2rem",
//               background: getBgColor(),
//               borderRadius: "16px",
//               border: `1px solid ${getBorderColor()}`,
//               color: getTextSecondaryStatic(isDarkMode),
//             }}
//           >
//             No banned users found
//           </div>
//         ) : (
//           <div
//             style={{
//               display: "grid",
//               gap: "1rem",
//               gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
//             }}
//           >
//             {bannedUsers.map((user) => (
//               <MutedBannedUserCard
//                 key={user._id}
//                 user={user}
//                 type="banned"
//                 onAction={onUnban}
//                 actionIcon={<FaUserPlus />}
//                 actionLabel="Unban"
//                 actionColor="#10b981"
//                 isDarkMode={isDarkMode}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // Muted/Banned User Card Component
// const MutedBannedUserCard = ({
//   user,
//   type,
//   onAction,
//   actionIcon,
//   actionLabel,
//   actionColor,
//   isDarkMode,
// }) => {
//   const getAvatarUrl = (name) => {
//     const initials =
//       name
//         ?.split(" ")
//         .map((n) => n[0])
//         .join("")
//         .toUpperCase()
//         .substring(0, 2) || "U";
//     return `https://ui-avatars.com/api/?name=${initials}&background=8b5cf6&color=fff&length=2&size=40`;
//   };
//   const formatDate = (date) =>
//     date ? new Date(date).toLocaleDateString() : "Indefinite";
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   return (
//     <motion.div
//       initial={{ opacity: 0, scale: 0.95 }}
//       animate={{ opacity: 1, scale: 1 }}
//       whileHover={{ y: -2 }}
//       style={{
//         background: getBgColor(),
//         borderRadius: "16px",
//         padding: "1rem",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//         borderLeft: `4px solid ${type === "muted" ? "#f59e0b" : "#ef4444"}`,
//         borderTop: `1px solid ${getBorderColor()}`,
//         borderRight: `1px solid ${getBorderColor()}`,
//         borderBottom: `1px solid ${getBorderColor()}`,
//         transition: "all 0.3s",
//       }}
//     >
//       <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
//         <img
//           src={user.profilePicture || getAvatarUrl(user.name)}
//           alt={user.name}
//           style={{
//             width: "50px",
//             height: "50px",
//             borderRadius: "50%",
//             objectFit: "cover",
//           }}
//         />
//         <div style={{ flex: 1 }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "0.5rem",
//               flexWrap: "wrap",
//             }}
//           >
//             <strong style={{ fontSize: "1rem", color: getTextColor() }}>
//               {user.name}
//             </strong>
//             <span
//               style={{
//                 fontSize: "0.7rem",
//                 padding: "0.2rem 0.5rem",
//                 borderRadius: "12px",
//                 background: type === "muted" ? "#f59e0b" : "#ef4444",
//                 color: "white",
//               }}
//             >
//               {type === "muted" ? "Muted" : "Banned"}
//             </span>
//           </div>
//           <div
//             style={{
//               fontSize: "0.8rem",
//               color: getTextSecondaryStatic(isDarkMode),
//               marginTop: "0.2rem",
//             }}
//           >
//             {user.email} | {user.usn}
//           </div>
//           <div
//             style={{
//               fontSize: "0.75rem",
//               color: getTextSecondaryStatic(isDarkMode),
//               marginTop: "0.2rem",
//             }}
//           >
//             {type === "muted"
//               ? `Muted until: ${formatDate(user.mutedUntil)}`
//               : `Banned until: ${formatDate(user.bannedUntil)} ${user.banReason ? `| Reason: ${user.banReason}` : ""}`}
//           </div>
//         </div>
//         <button
//           onClick={() => onAction(user._id)}
//           style={{
//             padding: "0.5rem 1rem",
//             background: actionColor,
//             color: "white",
//             border: "none",
//             borderRadius: "10px",
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             gap: "0.3rem",
//             fontSize: "0.85rem",
//             transition: "transform 0.2s",
//           }}
//           onMouseEnter={(e) =>
//             (e.currentTarget.style.transform = "scale(1.05)")
//           }
//           onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
//         >
//           {actionIcon} {actionLabel}
//         </button>
//       </div>
//     </motion.div>
//   );
// };

// // Moderate Modal Component
// const ModerateModal = ({
//   title,
//   item,
//   action,
//   setAction,
//   note,
//   setNote,
//   onConfirm,
//   onClose,
//   isAdmin,
//   isDarkMode,
// }) => {
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: "rgba(0,0,0,0.5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1000,
//       }}
//       onClick={onClose}
//     >
//       <motion.div
//         initial={{ scale: 0.9, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         style={{
//           background: getBgColor(),
//           padding: "2rem",
//           borderRadius: "24px",
//           maxWidth: "500px",
//           width: "90%",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <h3 style={{ color: getTextColor(), marginBottom: "1rem" }}>{title}</h3>
//         <p
//           style={{
//             color: getTextSecondaryStatic(isDarkMode),
//             marginBottom: "1rem",
//           }}
//         >
//           <strong>Item:</strong> {item?.title || item?.content}
//         </p>
//         <p
//           style={{
//             color: getTextSecondaryStatic(isDarkMode),
//             marginBottom: "1rem",
//           }}
//         >
//           <strong>Reported by:</strong> {item?.reports?.length || 0} users
//         </p>
//         <div style={{ marginBottom: "1rem" }}>
//           <label
//             style={{
//               display: "block",
//               marginBottom: "0.5rem",
//               color: getTextColor(),
//             }}
//           >
//             Action:
//           </label>
//           <select
//             value={action}
//             onChange={(e) => setAction(e.target.value)}
//             style={{
//               width: "100%",
//               padding: "0.8rem",
//               border: `2px solid ${getBorderColor()}`,
//               borderRadius: "12px",
//               background: getInputBackgroundStatic(isDarkMode),
//               color: getTextColor(),
//             }}
//           >
//             <option value="">Select action</option>
//             <option value="keep">Keep (Clear reports)</option>
//             <option value="warning">Send Warning</option>
//             <option value="hide">Hide Content</option>
//             {isAdmin && <option value="delete">Delete Permanently</option>}
//           </select>
//         </div>
//         <div style={{ marginBottom: "1rem" }}>
//           <label
//             style={{
//               display: "block",
//               marginBottom: "0.5rem",
//               color: getTextColor(),
//             }}
//           >
//             Moderation Note (optional):
//           </label>
//           <textarea
//             value={note}
//             onChange={(e) => setNote(e.target.value)}
//             rows="3"
//             style={{
//               width: "100%",
//               padding: "0.8rem",
//               border: `2px solid ${getBorderColor()}`,
//               borderRadius: "12px",
//               background: getInputBackgroundStatic(isDarkMode),
//               color: getTextColor(),
//             }}
//             placeholder="Add a note about this moderation..."
//           />
//         </div>
//         <div
//           style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
//         >
//           <button
//             onClick={onClose}
//             style={{
//               padding: "0.8rem 2rem",
//               background: "#6c757d",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               cursor: "pointer",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={onConfirm}
//             style={{
//               padding: "0.8rem 2rem",
//               background: "#8b5cf6",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               cursor: "pointer",
//             }}
//           >
//             Apply Action
//           </button>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// // Reply Modal Component
// const ReplyModal = ({
//   selectedContact,
//   replyText,
//   setReplyText,
//   setShowReplyModal,
//   handleReplyContact,
//   isDarkMode,
// }) => {
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: "rgba(0,0,0,0.5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1000,
//       }}
//       onClick={() => setShowReplyModal(false)}
//     >
//       <motion.div
//         initial={{ scale: 0.9, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         style={{
//           background: getBgColor(),
//           borderRadius: "24px",
//           maxWidth: "500px",
//           width: "90%",
//           padding: "2rem",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <h3 style={{ marginBottom: "1rem", color: getTextColor() }}>
//           Reply to {selectedContact.name}
//         </h3>
//         <p
//           style={{
//             color: getTextSecondaryStatic(isDarkMode),
//             marginBottom: "0.5rem",
//           }}
//         >
//           <strong>Subject:</strong> {selectedContact.subject}
//         </p>
//         <div
//           style={{
//             background: isDarkMode ? "rgba(139,92,246,0.1)" : "#f8f9fa",
//             padding: "1rem",
//             borderRadius: "12px",
//             marginBottom: "1rem",
//             border: `1px solid ${getBorderColor()}`,
//           }}
//         >
//           <p style={{ whiteSpace: "pre-wrap", color: getTextColor() }}>
//             {selectedContact.message}
//           </p>
//         </div>
//         <textarea
//           value={replyText}
//           onChange={(e) => setReplyText(e.target.value)}
//           rows="4"
//           placeholder="Type your reply here..."
//           style={{
//             width: "100%",
//             padding: "0.8rem",
//             border: `2px solid ${getBorderColor()}`,
//             borderRadius: "12px",
//             marginBottom: "1rem",
//             resize: "vertical",
//             background: getInputBackgroundStatic(isDarkMode),
//             color: getTextColor(),
//           }}
//         />
//         <div
//           style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
//         >
//           <button
//             onClick={() => setShowReplyModal(false)}
//             style={{
//               padding: "0.5rem 1rem",
//               background: "#6c757d",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               cursor: "pointer",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleReplyContact}
//             style={{
//               padding: "0.5rem 1rem",
//               background: "#10b981",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               gap: "0.3rem",
//             }}
//           >
//             <FaPaperPlane /> Send Reply
//           </button>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// // Reject Modal Component
// const RejectModal = ({
//   isOpen,
//   onClose,
//   onConfirm,
//   reason,
//   setReason,
//   noteTitle,
//   isDarkMode,
// }) => {
//   if (!isOpen) return null;
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: "rgba(0,0,0,0.5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1000,
//       }}
//       onClick={onClose}
//     >
//       <motion.div
//         initial={{ scale: 0.9, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         style={{
//           background: getBgColor(),
//           padding: "2rem",
//           borderRadius: "24px",
//           maxWidth: "500px",
//           width: "90%",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "1rem",
//             marginBottom: "1rem",
//           }}
//         >
//           <FaExclamationTriangle size={30} color="#f59e0b" />
//           <h3 style={{ color: getTextColor() }}>Reject Note</h3>
//         </div>
//         <p
//           style={{
//             color: getTextSecondaryStatic(isDarkMode),
//             marginBottom: "1rem",
//           }}
//         >
//           Rejecting: <strong>{noteTitle}</strong>
//         </p>
//         <textarea
//           value={reason}
//           onChange={(e) => setReason(e.target.value)}
//           placeholder="Enter rejection reason..."
//           rows="4"
//           style={{
//             width: "100%",
//             padding: "0.8rem",
//             border: `2px solid ${getBorderColor()}`,
//             borderRadius: "12px",
//             marginBottom: "1rem",
//             fontSize: "1rem",
//             background: getInputBackgroundStatic(isDarkMode),
//             color: getTextColor(),
//           }}
//           autoFocus
//         />
//         <div
//           style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
//         >
//           <button
//             onClick={onClose}
//             style={{
//               padding: "0.8rem 2rem",
//               background: "#6c757d",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               cursor: "pointer",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={onConfirm}
//             style={{
//               padding: "0.8rem 2rem",
//               background: "#ef4444",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               cursor: "pointer",
//             }}
//           >
//             Reject Note
//           </button>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// // Delete Modal Component
// const DeleteModal = ({ isOpen, onClose, onConfirm, noteTitle, isDarkMode }) => {
//   if (!isOpen) return null;
//   const getBgColor = () => getCardBackgroundStatic(isDarkMode);
//   const getTextColor = () => getTextColorStatic(isDarkMode);
//   const getBorderColor = () => getBorderColorStatic(isDarkMode);

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: "rgba(0,0,0,0.5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1000,
//       }}
//       onClick={onClose}
//     >
//       <motion.div
//         initial={{ scale: 0.9, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         style={{
//           background: getBgColor(),
//           padding: "2rem",
//           borderRadius: "24px",
//           maxWidth: "500px",
//           width: "90%",
//           border: `1px solid ${getBorderColor()}`,
//         }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "1rem",
//             marginBottom: "1rem",
//           }}
//         >
//           <FaExclamationTriangle size={30} color="#ef4444" />
//           <h3 style={{ color: getTextColor() }}>Delete Note</h3>
//         </div>
//         <p
//           style={{
//             color: getTextSecondaryStatic(isDarkMode),
//             marginBottom: "1rem",
//           }}
//         >
//           Are you sure you want to permanently delete{" "}
//           <strong>"{noteTitle}"</strong>?
//         </p>
//         <p
//           style={{ color: "#ef4444", marginBottom: "2rem", fontSize: "0.9rem" }}
//         >
//           This action cannot be undone!
//         </p>
//         <div
//           style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
//         >
//           <button
//             onClick={onClose}
//             style={{
//               padding: "0.8rem 2rem",
//               background: "#6c757d",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               cursor: "pointer",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={onConfirm}
//             style={{
//               padding: "0.8rem 2rem",
//               background: "#ef4444",
//               color: "white",
//               border: "none",
//               borderRadius: "10px",
//               cursor: "pointer",
//             }}
//           >
//             Delete Permanently
//           </button>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default AdminDashboard;

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaUsers,
  FaFileAlt,
  FaClock,
  FaCheck,
  FaTimes,
  FaDownload,
  FaChartBar,
  FaUserCheck,
  FaUserTimes,
  FaTrash,
  FaEye,
  FaSearch,
  FaFilter,
  FaSort,
  FaEdit,
  FaBan,
  FaCheckCircle,
  FaExclamationTriangle,
  FaCog,
  FaFilePdf,
  FaFileWord,
  FaFilePowerpoint,
  FaImage,
  FaEllipsisV,
  FaEnvelope,
  FaFlag,
  FaReply,
  FaComments,
  FaPaperPlane,
  FaCalculator,
  FaGlobe,
  FaMicrophoneSlash,
  FaMicrophone,
  FaUserSlash,
  FaUserPlus,
  FaVolumeMute,
  FaThumbsUp,
  FaThumbsDown,
  FaSpinner,
  FaShieldAlt,
  FaRocket,
  FaArrowRight,
  FaCalendarAlt,
  FaBuilding,
  FaTrophy,
  FaStar,
  FaAward,
  FaTimesCircle,
  FaBell,
  FaBullhorn,
  FaMapSigns,
} from "react-icons/fa";
import {
  FiUploadCloud,
  FiDownload,
  FiHeart,
  FiEye,
  FiBookOpen,
  FiTrendingUp,
  FiBarChart2,
  FiGrid,
  FiList,
  FiActivity,
  FiTarget,
  FiFolder,
} from "react-icons/fi";
import { HiOutlineSparkles } from "react-icons/hi";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../components/common/Loader";
import CGPASchemeManager from "../components/cgpa/CGPASchemeManager";
import AdminSGPA from "../components/sgpa/AdminSGPA";
import ResultURLManager from "../components/admin/ResultURLManager";
import RecentResultsManager from "../components/admin/RecentResultsManager";
import PYQManagement from "../components/admin/PYQManagement";
import MQPManagement from "../components/admin/MQPManagement";
import AnnouncementManager from "../components/admin/AnnouncementManager";
import LearningRoadmapManager from "../components/admin/LearningRoadmapManager";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [pendingNotes, setPendingNotes] = useState([]);
  const [users, setUsers] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [contactStats, setContactStats] = useState({});
  const [reportedComments, setReportedComments] = useState([]);
  const [reportedNotes, setReportedNotes] = useState([]);
  const [selectedNote, setSelectedNote] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [activeTab, setActiveTab] = useState("pending");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [branchFilter, setBranchFilter] = useState("all");
  const [selectedNotes, setSelectedNotes] = useState([]);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [isDarkMode, setIsDarkMode] = useState(false);

  // State for muted/banned users
  const [mutedUsers, setMutedUsers] = useState([]);
  const [bannedUsers, setBannedUsers] = useState([]);
  const [loadingMutedBanned, setLoadingMutedBanned] = useState(false);
  const [mutedSearchTerm, setMutedSearchTerm] = useState("");
  const [bannedSearchTerm, setBannedSearchTerm] = useState("");

  // Dark mode detection
  useEffect(() => {
    const checkDarkMode = () => {
      const dark =
        document.documentElement.getAttribute("data-theme") === "dark";
      setIsDarkMode(dark);
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  const isAdmin = user?.role === "admin";
  const isModerator = user?.role === "moderator";

  const branches = ["CSE", "ISE", "ECE", "EEE", "MECH", "CIVIL", "AIML", "DS"];
  const statuses = ["pending", "approved", "rejected"];

  useEffect(() => {
    if (!isAuthenticated || (!isAdmin && !isModerator)) {
      navigate("/");
      toast.error("Unauthorized access");
      return;
    }
    fetchPendingNotes();
    fetchReportedComments();
    fetchReportedNotes();
    fetchContacts();
    fetchContactStats();
    if (isAdmin) {
      fetchDashboardData();
      fetchUsers();
      fetchMutedAndBannedUsers();
    }
  }, [isAuthenticated, user, navigate]);

  const fetchMutedAndBannedUsers = async () => {
    setLoadingMutedBanned(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/admin/users", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const allUsers = response.data.users || [];
      const now = new Date();
      const muted = allUsers.filter(
        (u) =>
          u.isMuted === true && (!u.mutedUntil || new Date(u.mutedUntil) > now),
      );
      const banned = allUsers.filter(
        (u) =>
          u.isBanned === true &&
          (!u.bannedUntil || new Date(u.bannedUntil) > now),
      );
      setMutedUsers(muted);
      setBannedUsers(banned);
    } catch (error) {
      console.error("Fetch muted/banned users error:", error);
      toast.error("Failed to fetch muted/banned users");
    } finally {
      setLoadingMutedBanned(false);
    }
  };

  const handleUnmuteUserFromAdmin = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `/api/chat/user/${userId}/unmute`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success("User unmuted successfully");
      fetchMutedAndBannedUsers();
      fetchUsers();
    } catch (error) {
      console.error("Unmute error:", error);
      toast.error(error.response?.data?.message || "Failed to unmute user");
    }
  };

  const handleUnbanUserFromAdmin = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `/api/chat/user/${userId}/unban`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success("User unbanned successfully");
      fetchMutedAndBannedUsers();
      fetchUsers();
    } catch (error) {
      console.error("Unban error:", error);
      toast.error(error.response?.data?.message || "Failed to unban user");
    }
  };

  const fetchDashboardData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/admin/dashboard", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDashboardData(response.data);
    } catch (error) {
      console.error("Fetch dashboard error:", error);
      toast.error("Failed to fetch dashboard data");
    }
  };

  const fetchPendingNotes = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/admin/notes?status=pending", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPendingNotes(response.data.notes || []);
    } catch (error) {
      console.error("Fetch pending notes error:", error);
      toast.error("Failed to fetch pending notes");
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/admin/users", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(response.data.users || []);
    } catch (error) {
      console.error("Fetch users error:", error);
    }
  };

  const fetchContacts = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/contact", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setContacts(response.data.contacts || []);
    } catch (error) {
      console.error("Fetch contacts error:", error);
      toast.error("Failed to fetch contact messages");
    }
  };

  const fetchContactStats = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/contact/stats/summary", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setContactStats(response.data);
    } catch (error) {
      console.error("Fetch contact stats error:", error);
    }
  };

  const handleUpdateContactStatus = async (id, status) => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `/api/contact/${id}`,
        { status },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success("Status updated");
      fetchContacts();
      fetchContactStats();
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  const handleReplyContact = async () => {
    if (!replyText.trim()) {
      toast.error("Please enter a reply");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `/api/contact/${selectedContact._id}`,
        {
          status: "replied",
          reply: replyText,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success("Reply sent");
      setShowReplyModal(false);
      setSelectedContact(null);
      setReplyText("");
      fetchContacts();
      fetchContactStats();
    } catch (error) {
      toast.error("Failed to send reply");
    }
  };

  const handleDeleteContact = async (id) => {
    if (!window.confirm("Are you sure you want to delete this message?"))
      return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/api/contact/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Message deleted");
      fetchContacts();
      fetchContactStats();
    } catch (error) {
      toast.error("Failed to delete message");
    }
  };

  const fetchReportedComments = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/admin/comments/reported", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setReportedComments(response.data.comments || []);
    } catch (error) {
      console.error("Fetch reported comments error:", error);
    }
  };

  const fetchReportedNotes = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/admin/notes/reported", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setReportedNotes(response.data.notes || []);
    } catch (error) {
      console.error("Fetch reported notes error:", error);
      toast.error("Failed to fetch reported notes");
    }
  };

  const handleModerateComment = async (commentId, action, moderationNote) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `/api/admin/reported-comments/${commentId}/moderate`,
        { action, moderationNote },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (response.data.success) {
        toast.success(response.data.message);
        fetchReportedComments();
        if (isAdmin) fetchDashboardData();
      }
    } catch (error) {
      console.error("Moderate comment error:", error);
      toast.error("Failed to moderate comment");
    }
  };

  const handleModerateNote = async (noteId, action, moderationNote) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `/api/admin/reported-notes/${noteId}/moderate`,
        { action, moderationNote },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (response.data.success) {
        toast.success(response.data.message);
        fetchReportedNotes();
        if (isAdmin) fetchDashboardData();
      }
    } catch (error) {
      console.error("Moderate note error:", error);
      toast.error("Failed to moderate note");
    }
  };

  const handleApprove = async (noteId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `/api/admin/notes/${noteId}/approve`,
        {
          comments: `Approved by ${user?.role === "admin" ? "Admin" : "Moderator"}`,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.success) {
        toast.success("Note approved successfully");
        fetchPendingNotes();
        if (isAdmin) fetchDashboardData();
      }
    } catch (error) {
      toast.error("Failed to approve note");
    }
  };

  const handleReject = async () => {
    if (!rejectionReason.trim()) {
      toast.error("Please provide a rejection reason");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `/api/admin/notes/${selectedNote._id}/reject`,
        {
          reason: rejectionReason,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.success) {
        toast.success("Note rejected");
        setShowRejectModal(false);
        setRejectionReason("");
        setSelectedNote(null);
        fetchPendingNotes();
        if (isAdmin) fetchDashboardData();
      }
    } catch (error) {
      toast.error("Failed to reject note");
    }
  };

  const handleDeleteNote = async () => {
    if (!isAdmin) {
      toast.error("Only admins can delete notes");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        `/api/admin/notes/${selectedNote._id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.success) {
        toast.success("Note deleted permanently");
        setShowDeleteModal(false);
        setSelectedNote(null);
        fetchPendingNotes();
        fetchDashboardData();
      }
    } catch (error) {
      toast.error("Failed to delete note");
    }
  };

  const handleBulkApprove = async () => {
    if (selectedNotes.length === 0) {
      toast.error("Select notes to approve");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        "/api/admin/notes/bulk/approve",
        {
          noteIds: selectedNotes,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.success) {
        toast.success(response.data.message);
        setSelectedNotes([]);
        setShowBulkActions(false);
        fetchPendingNotes();
        if (isAdmin) fetchDashboardData();
      }
    } catch (error) {
      toast.error("Failed to approve notes");
    }
  };

  const handleBulkReject = async () => {
    if (selectedNotes.length === 0) {
      toast.error("Select notes to reject");
      return;
    }
    const reason = prompt("Enter rejection reason for all selected notes:");
    if (!reason) return;
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        "/api/admin/notes/bulk/reject",
        {
          noteIds: selectedNotes,
          reason,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.success) {
        toast.success(response.data.message);
        setSelectedNotes([]);
        setShowBulkActions(false);
        fetchPendingNotes();
        if (isAdmin) fetchDashboardData();
      }
    } catch (error) {
      toast.error("Failed to reject notes");
    }
  };

  const handleToggleUserStatus = async (userId) => {
    if (!isAdmin) {
      toast.error("Only admins can manage users");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `/api/admin/users/${userId}/toggle-status`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.success) {
        toast.success(response.data.message);
        fetchUsers();
        fetchMutedAndBannedUsers();
      }
    } catch (error) {
      toast.error("Failed to toggle user status");
    }
  };

  const handleChangeUserRole = async (userId, newRole) => {
    if (!isAdmin) {
      toast.error("Only admins can change user roles");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `/api/admin/users/${userId}/role`,
        {
          role: newRole,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.success) {
        toast.success("User role updated");
        fetchUsers();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update role");
    }
  };

  if (loading) return <Loader />;

  // Helper functions for styling
  const getTextColorStatic = (isDarkMode) =>
    isDarkMode ? "#f1f5f9" : "#1e293b";
  const getTextSecondaryStatic = (isDarkMode) =>
    isDarkMode ? "#94a3b8" : "#64748b";
  const getBorderColorStatic = (isDarkMode) =>
    isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
  const getCardBackgroundStatic = (isDarkMode) =>
    isDarkMode ? "rgba(30, 30, 45, 0.8)" : "rgba(255, 255, 255, 0.9)";
  const getInputBackgroundStatic = (isDarkMode) =>
    isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff";

  const filteredMutedUsers = mutedUsers.filter(
    (u) =>
      u.name?.toLowerCase().includes(mutedSearchTerm.toLowerCase()) ||
      u.email?.toLowerCase().includes(mutedSearchTerm.toLowerCase()) ||
      u.usn?.toLowerCase().includes(mutedSearchTerm.toLowerCase()),
  );

  const filteredBannedUsers = bannedUsers.filter(
    (u) =>
      u.name?.toLowerCase().includes(bannedSearchTerm.toLowerCase()) ||
      u.email?.toLowerCase().includes(bannedSearchTerm.toLowerCase()) ||
      u.usn?.toLowerCase().includes(bannedSearchTerm.toLowerCase()),
  );

  return (
    <div
      style={{
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "2rem",
        background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {/* Animated Background Grid */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: "none",
          zIndex: 0,
          backgroundImage: `radial-gradient(circle at 1px 1px, ${isDarkMode ? "rgba(139,92,246,0.1)" : "rgba(139,92,246,0.08)"} 1px, transparent 1px)`,
          backgroundSize: "40px 40px",
        }}
      />

      {/* Floating Gradient Orbs */}
      <motion.div
        animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        style={{
          position: "fixed",
          top: "10%",
          left: "-5%",
          width: "300px",
          height: "300px",
          background:
            "radial-gradient(circle, rgba(139,92,246,0.3) 0%, transparent 70%)",
          borderRadius: "50%",
          filter: "blur(60px)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <motion.div
        animate={{ x: [0, -100, 0], y: [0, 80, 0] }}
        transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
        style={{
          position: "fixed",
          bottom: "10%",
          right: "-5%",
          width: "350px",
          height: "350px",
          background:
            "radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 70%)",
          borderRadius: "50%",
          filter: "blur(60px)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, type: "spring", stiffness: 300 }}
        style={{
          background: "linear-gradient(135deg, #1e1b4b 0%, #2e1065 100%)",
          color: "white",
          padding: "2rem",
          borderRadius: "28px",
          marginBottom: "2rem",
          position: "relative",
          zIndex: 1,
          overflow: "hidden",
        }}
      >
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.1, 0.3] }}
          transition={{ duration: 4, repeat: Infinity }}
          style={{
            position: "absolute",
            top: -50,
            right: -50,
            width: 200,
            height: 200,
            background:
              "radial-gradient(circle, rgba(139,92,246,0.4) 0%, transparent 70%)",
            borderRadius: "50%",
          }}
        />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              marginBottom: "0.5rem",
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
                width: "50px",
                height: "50px",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <HiOutlineSparkles size={28} color="white" />
            </div>
            <h1
              style={{ fontSize: "2rem", fontWeight: "bold", color: "white" }}
            >
              {isAdmin ? "Admin Dashboard" : "Moderator Dashboard"}
            </h1>
          </div>
          <p
            style={{
              opacity: 0.9,
              color: "rgba(255,255,255,0.9)",
              marginLeft: "3rem",
            }}
          >
            Welcome back, {user?.name}.{" "}
            {isModerator && "You can review and approve notes."}
          </p>
        </div>
      </motion.div>

      {/* Stats Cards Grid */}
      {dashboardData && isAdmin && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "1.5rem",
            marginBottom: "2rem",
            position: "relative",
            zIndex: 1,
          }}
        >
          <StatCard
            icon={<FaClock />}
            label="Pending Notes"
            value={dashboardData.stats.pendingNotes}
            color="#f59e0b"
            isDarkMode={isDarkMode}
          />
          <StatCard
            icon={<FaCheckCircle />}
            label="Approved Notes"
            value={dashboardData.stats.approvedNotes}
            color="#10b981"
            isDarkMode={isDarkMode}
          />
          <StatCard
            icon={<FaTimesCircle />}
            label="Rejected Notes"
            value={dashboardData.stats.rejectedNotes}
            color="#ef4444"
            isDarkMode={isDarkMode}
          />
          <StatCard
            icon={<FaFlag />}
            label="Reported Notes"
            value={reportedNotes.length}
            color="#8b5cf6"
            isDarkMode={isDarkMode}
          />
          <StatCard
            icon={<FaComments />}
            label="Reported Comments"
            value={reportedComments.length}
            color="#06b6d4"
            isDarkMode={isDarkMode}
          />
          <StatCard
            icon={<FaUsers />}
            label="Total Users"
            value={dashboardData.stats.totalUsers}
            color="#8b5cf6"
            isDarkMode={isDarkMode}
          />
          <StatCard
            icon={<FaEnvelope />}
            label="Contact Messages"
            value={contactStats.total || 0}
            color="#f59e0b"
            isDarkMode={isDarkMode}
          />
          <StatCard
            icon={<FaMicrophoneSlash />}
            label="Muted Users"
            value={mutedUsers.length}
            color="#f59e0b"
            isDarkMode={isDarkMode}
          />
          <StatCard
            icon={<FaBan />}
            label="Banned Users"
            value={bannedUsers.length}
            color="#ef4444"
            isDarkMode={isDarkMode}
          />
        </motion.div>
      )}

      {/* Navigation Tabs */}
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
          borderBottom: `2px solid ${getBorderColorStatic(isDarkMode)}`,
          marginBottom: "2rem",
          flexWrap: "wrap",
          paddingBottom: "0.5rem",
          background: getCardBackgroundStatic(isDarkMode),
          backdropFilter: "blur(20px)",
          padding: "0.5rem 1rem",
          borderRadius: "20px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <TabButton
          active={activeTab === "pending"}
          onClick={() => setActiveTab("pending")}
          icon={<FaClock color="#f59e0b" />}
          label={`Pending (${pendingNotes.length})`}
          isDarkMode={isDarkMode}
        />
        <TabButton
          active={activeTab === "reported-notes"}
          onClick={() => setActiveTab("reported-notes")}
          icon={<FaFlag color="#ef4444" />}
          label={`Reported Notes (${reportedNotes.length})`}
          isDarkMode={isDarkMode}
        />
        <TabButton
          active={activeTab === "reported-comments"}
          onClick={() => setActiveTab("reported-comments")}
          icon={<FaComments color="#06b6d4" />}
          label={`Reported Comments (${reportedComments.length})`}
          isDarkMode={isDarkMode}
        />
        <TabButton
          active={activeTab === "contacts"}
          onClick={() => setActiveTab("contacts")}
          icon={<FaEnvelope color="#8b5cf6" />}
          label={`Contacts (${contactStats.total || 0})`}
          isDarkMode={isDarkMode}
        />
        <TabButton
          active={activeTab === "cgpa-schemes"}
          onClick={() => setActiveTab("cgpa-schemes")}
          icon={<FaCalculator color="#8b5cf6" />}
          label="CGPA Schemes"
          isDarkMode={isDarkMode}
        />
        <TabButton
          active={activeTab === "sgpa"}
          onClick={() => setActiveTab("sgpa")}
          icon={<FaCalculator color="#8b5cf6" />}
          label="SGPA Manager"
          isDarkMode={isDarkMode}
        />
        <TabButton
          active={activeTab === "recent-results"}
          onClick={() => setActiveTab("recent-results")}
          icon={<FaGlobe color="#3b82f6" />}
          label="Recent Results"
          isDarkMode={isDarkMode}
        />
        <TabButton
          active={activeTab === "pyqs"}
          onClick={() => setActiveTab("pyqs")}
          icon={<FaFilePdf color="#ef4444" />}
          label="PYQ Management"
          isDarkMode={isDarkMode}
        />
        <TabButton
          active={activeTab === "mqps"}
          onClick={() => setActiveTab("mqps")}
          icon={<FaFilePdf color="#8b5cf6" />}
          label="MQP Management"
          isDarkMode={isDarkMode}
        />

        <TabButton
          active={activeTab === "learning-roadmap"}
          onClick={() => navigate("/admin/domains")}
          icon={<FaMapSigns color="#10b981" />}
          label="Learning Roadmap"
          isDarkMode={isDarkMode}
        />

        <TabButton
          active={activeTab === "announcements"}
          onClick={() => setActiveTab("announcements")}
          icon={<FaBell color="#f59e0b" />}
          label="Announcements"
          isDarkMode={isDarkMode}
        />
        {isAdmin && (
          <TabButton
            active={activeTab === "muted-banned"}
            onClick={() => setActiveTab("muted-banned")}
            icon={<FaMicrophoneSlash color="#f59e0b" />}
            label={`Muted/Banned (${mutedUsers.length + bannedUsers.length})`}
            isDarkMode={isDarkMode}
          />
        )}
        {isAdmin && (
          <TabButton
            active={activeTab === "dashboard"}
            onClick={() => setActiveTab("dashboard")}
            icon={<FaChartBar color="#8b5cf6" />}
            label="Dashboard"
            isDarkMode={isDarkMode}
          />
        )}
        {isAdmin && (
          <TabButton
            active={activeTab === "users"}
            onClick={() => setActiveTab("users")}
            icon={<FaUsers color="#8b5cf6" />}
            label="Users"
            isDarkMode={isDarkMode}
          />
        )}
        {isAdmin && (
          <TabButton
            active={activeTab === "result-urls"}
            onClick={() => setActiveTab("result-urls")}
            icon={<FaGlobe color="#3b82f6" />}
            label="Latest Result URLs"
            isDarkMode={isDarkMode}
          />
        )}
      </div>

      {/* Tab Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          style={{
            background: getCardBackgroundStatic(isDarkMode),
            backdropFilter: "blur(20px)",
            borderRadius: "28px",
            padding: "1.5rem",
            border: `1px solid ${getBorderColorStatic(isDarkMode)}`,
            position: "relative",
            zIndex: 1,
          }}
        >
          {activeTab === "pending" && (
            <PendingNotesTab
              notes={pendingNotes}
              onApprove={handleApprove}
              onReject={(note) => {
                setSelectedNote(note);
                setShowRejectModal(true);
              }}
              onDelete={
                isAdmin
                  ? (note) => {
                      setSelectedNote(note);
                      setShowDeleteModal(true);
                    }
                  : null
              }
              selectedNotes={selectedNotes}
              setSelectedNotes={setSelectedNotes}
              showBulkActions={showBulkActions}
              setShowBulkActions={setShowBulkActions}
              onBulkApprove={handleBulkApprove}
              onBulkReject={handleBulkReject}
              isAdmin={isAdmin}
              isDarkMode={isDarkMode}
            />
          )}
          {activeTab === "reported-notes" && (
            <ReportedNotesTab
              notes={reportedNotes}
              onModerate={handleModerateNote}
              isAdmin={isAdmin}
              isDarkMode={isDarkMode}
            />
          )}
          {activeTab === "reported-comments" && (
            <ReportedCommentsTab
              comments={reportedComments}
              onModerate={handleModerateComment}
              isAdmin={isAdmin}
              isDarkMode={isDarkMode}
            />
          )}
          {activeTab === "contacts" && (
            <ContactsTab
              contacts={contacts}
              onUpdateStatus={handleUpdateContactStatus}
              onReply={(contact) => {
                setSelectedContact(contact);
                setReplyText("");
                setShowReplyModal(true);
              }}
              onDelete={handleDeleteContact}
              isDarkMode={isDarkMode}
            />
          )}
          {activeTab === "cgpa-schemes" && <CGPASchemeManager />}
          {activeTab === "sgpa" && <AdminSGPA />}
          {activeTab === "recent-results" && <RecentResultsManager />}
          {activeTab === "pyqs" && <PYQManagement isDarkMode={isDarkMode} />}
          {activeTab === "mqps" && <MQPManagement isDarkMode={isDarkMode} />}
          {activeTab === "announcements" && isAdmin && (
            <AnnouncementManager isDarkMode={isDarkMode} />
          )}
          {activeTab === "muted-banned" && isAdmin && (
            <MutedBannedUsersTab
              mutedUsers={filteredMutedUsers}
              bannedUsers={filteredBannedUsers}
              onUnmute={handleUnmuteUserFromAdmin}
              onUnban={handleUnbanUserFromAdmin}
              onRefresh={fetchMutedAndBannedUsers}
              mutedSearchTerm={mutedSearchTerm}
              setMutedSearchTerm={setMutedSearchTerm}
              bannedSearchTerm={bannedSearchTerm}
              setBannedSearchTerm={setBannedSearchTerm}
              loading={loadingMutedBanned}
              isDarkMode={isDarkMode}
            />
          )}
          {activeTab === "dashboard" && isAdmin && dashboardData && (
            <DashboardTab data={dashboardData} isDarkMode={isDarkMode} />
          )}
          {activeTab === "users" && isAdmin && (
            <UsersTab
              users={users}
              onToggleStatus={handleToggleUserStatus}
              onChangeRole={handleChangeUserRole}
              currentAdmin={user}
              isDarkMode={isDarkMode}
            />
          )}
          {activeTab === "result-urls" && isAdmin && <ResultURLManager />}
        </motion.div>
      </AnimatePresence>

      {/* Modals */}
      {showReplyModal && selectedContact && (
        <ReplyModal
          selectedContact={selectedContact}
          replyText={replyText}
          setReplyText={setReplyText}
          setShowReplyModal={setShowReplyModal}
          handleReplyContact={handleReplyContact}
          isDarkMode={isDarkMode}
        />
      )}
      <RejectModal
        isOpen={showRejectModal}
        onClose={() => {
          setShowRejectModal(false);
          setRejectionReason("");
          setSelectedNote(null);
        }}
        onConfirm={handleReject}
        reason={rejectionReason}
        setReason={setRejectionReason}
        noteTitle={selectedNote?.title}
        isDarkMode={isDarkMode}
      />
      {isAdmin && (
        <DeleteModal
          isOpen={showDeleteModal}
          onClose={() => {
            setShowDeleteModal(false);
            setSelectedNote(null);
          }}
          onConfirm={handleDeleteNote}
          noteTitle={selectedNote?.title}
          isDarkMode={isDarkMode}
        />
      )}
    </div>
  );
};

// ==================== HELPER COMPONENTS ====================

// Stat Card Component
const StatCard = ({ icon, label, value, color, isDarkMode }) => (
  <motion.div
    whileHover={{ y: -5, scale: 1.02 }}
    transition={{ type: "spring", stiffness: 400, damping: 17 }}
    style={{
      background: getCardBackgroundStatic(isDarkMode),
      backdropFilter: "blur(20px)",
      padding: "1.2rem",
      borderRadius: "20px",
      boxShadow: isDarkMode
        ? "0 10px 30px -8px rgba(0,0,0,0.3)"
        : "0 10px 30px -8px rgba(0,0,0,0.1)",
      textAlign: "center",
      border: `1px solid ${getBorderColorStatic(isDarkMode)}`,
      cursor: "pointer",
    }}
  >
    <div style={{ fontSize: "2rem", color: color, marginBottom: "0.5rem" }}>
      {icon}
    </div>
    <h3
      style={{
        fontSize: "1.8rem",
        color: getTextColorStatic(isDarkMode),
        marginBottom: "0.2rem",
        fontWeight: "bold",
      }}
    >
      {value}
    </h3>
    <p
      style={{
        color: getTextSecondaryStatic(isDarkMode),
        fontSize: "0.8rem",
        fontWeight: "500",
      }}
    >
      {label}
    </p>
  </motion.div>
);

// Tab Button Component
const TabButton = ({ active, onClick, icon, label, isDarkMode }) => (
  <button
    onClick={onClick}
    style={{
      padding: "0.6rem 1.2rem",
      background: "none",
      border: "none",
      borderBottom: active ? "3px solid #8b5cf6" : "none",
      color: active ? "#8b5cf6" : isDarkMode ? "#94a3b8" : "#64748b",
      fontWeight: active ? "600" : "500",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      fontSize: "0.85rem",
      transition: "all 0.3s",
    }}
  >
    {icon} {label}
  </button>
);

// Helper functions
const getCardBackgroundStatic = (isDarkMode) =>
  isDarkMode ? "rgba(30, 30, 45, 0.8)" : "rgba(255, 255, 255, 0.9)";
const getTextColorStatic = (isDarkMode) => (isDarkMode ? "#f1f5f9" : "#1e293b");
const getTextSecondaryStatic = (isDarkMode) =>
  isDarkMode ? "#94a3b8" : "#64748b";
const getBorderColorStatic = (isDarkMode) =>
  isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
const getInputBackgroundStatic = (isDarkMode) =>
  isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff";

// Helper function for avatar
const getAvatarDataUrl = (name, size = 40) => {
  const initials =
    name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .substring(0, 2) || "U";
  const fontSize = size * 0.45;
  const yPos = size * 0.65;
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 ${size} ${size}'%3E%3Crect width='${size}' height='${size}' fill='%238b5cf6'/%3E%3Ctext x='${size / 2}' y='${yPos}' font-size='${fontSize}' text-anchor='middle' fill='white' font-family='Arial'%3E${initials}%3C/text%3E%3C/svg%3E`;
};

// Contacts Tab Component
const ContactsTab = ({
  contacts,
  onUpdateStatus,
  onReply,
  onDelete,
  isDarkMode,
}) => {
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  const getStatusBadge = (status) => {
    const statuses = {
      pending: { label: "Pending", color: "#f59e0b", icon: <FaClock /> },
      read: { label: "Read", color: "#06b6d4", icon: <FaEye /> },
      replied: { label: "Replied", color: "#10b981", icon: <FaReply /> },
      resolved: { label: "Resolved", color: "#6c757d", icon: <FaCheck /> },
    };
    const s = statuses[status] || statuses.pending;
    return (
      <span
        style={{
          background: s.color,
          color: "white",
          padding: "0.2rem 0.6rem",
          borderRadius: "20px",
          fontSize: "0.7rem",
          display: "inline-flex",
          alignItems: "center",
          gap: "0.3rem",
        }}
      >
        {s.icon} {s.label}
      </span>
    );
  };

  const filteredContacts = contacts.filter((contact) => {
    if (filter !== "all" && contact.status !== filter) return false;
    if (
      search &&
      !contact.name.toLowerCase().includes(search.toLowerCase()) &&
      !contact.email.toLowerCase().includes(search.toLowerCase())
    )
      return false;
    return true;
  });

  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  const getBorderLeftColor = (status) => {
    switch (status) {
      case "pending":
        return "#f59e0b";
      case "read":
        return "#06b6d4";
      case "replied":
        return "#10b981";
      case "resolved":
        return "#6c757d";
      default:
        return "#f59e0b";
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "1rem",
          marginBottom: "1.5rem",
          flexWrap: "wrap",
        }}
      >
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{
            padding: "0.5rem 1rem",
            border: `2px solid ${getBorderColor()}`,
            borderRadius: "12px",
            outline: "none",
            background: getInputBackgroundStatic(isDarkMode),
            color: getTextColor(),
          }}
        >
          <option value="all">All Messages</option>
          <option value="pending">Pending</option>
          <option value="read">Read</option>
          <option value="replied">Replied</option>
          <option value="resolved">Resolved</option>
        </select>
        <input
          type="text"
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            flex: 1,
            padding: "0.5rem 1rem",
            border: `2px solid ${getBorderColor()}`,
            borderRadius: "12px",
            outline: "none",
            background: getInputBackgroundStatic(isDarkMode),
            color: getTextColor(),
          }}
        />
      </div>
      {filteredContacts.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "3rem",
            background: getBgColor(),
            borderRadius: "20px",
            border: `1px solid ${getBorderColor()}`,
          }}
        >
          <FaEnvelope size={50} color={getTextSecondaryStatic(isDarkMode)} />
          <h3 style={{ margin: "1rem 0", color: getTextColor() }}>
            No Messages
          </h3>
          <p style={{ color: getTextSecondaryStatic(isDarkMode) }}>
            No contact messages found.
          </p>
        </div>
      ) : (
        <div style={{ display: "grid", gap: "1rem" }}>
          {filteredContacts.map((contact) => (
            <motion.div
              key={contact._id}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              style={{
                background: getBgColor(),
                padding: "1rem",
                borderRadius: "16px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                borderLeftWidth: "4px",
                borderLeftStyle: "solid",
                borderLeftColor: getBorderLeftColor(contact.status),
                borderTop: `1px solid ${getBorderColor()}`,
                borderRight: `1px solid ${getBorderColor()}`,
                borderBottom: `1px solid ${getBorderColor()}`,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  gap: "1rem",
                }}
              >
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.8rem",
                      flexWrap: "wrap",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <h3 style={{ margin: 0, color: getTextColor() }}>
                      {contact.name}
                    </h3>
                    <span
                      style={{
                        color: getTextSecondaryStatic(isDarkMode),
                        fontSize: "0.8rem",
                      }}
                    >
                      {contact.email}
                    </span>
                    {getStatusBadge(contact.status)}
                  </div>
                  <p
                    style={{
                      color: getTextColor(),
                      marginBottom: "0.3rem",
                      fontWeight: "500",
                    }}
                  >
                    {contact.subject}
                  </p>
                  <p
                    style={{
                      color: getTextSecondaryStatic(isDarkMode),
                      fontSize: "0.85rem",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {contact.message.substring(0, 100)}...
                  </p>
                  <p
                    style={{
                      color: getTextSecondaryStatic(isDarkMode),
                      fontSize: "0.7rem",
                    }}
                  >
                    Received: {new Date(contact.createdAt).toLocaleString()}
                  </p>
                </div>
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <button
                    onClick={() =>
                      window.open(`mailto:${contact.email}`, "_blank")
                    }
                    style={{
                      padding: "0.4rem 0.8rem",
                      background: "#06b6d4",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                    title="Email"
                  >
                    <FaEnvelope />
                  </button>
                  <button
                    onClick={() => onReply(contact)}
                    style={{
                      padding: "0.4rem 0.8rem",
                      background: "#10b981",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                    title="Reply"
                  >
                    <FaReply />
                  </button>
                  {contact.status !== "resolved" &&
                    contact.status !== "replied" && (
                      <button
                        onClick={() => onUpdateStatus(contact._id, "resolved")}
                        style={{
                          padding: "0.4rem 0.8rem",
                          background: "#6c757d",
                          color: "white",
                          border: "none",
                          borderRadius: "8px",
                          cursor: "pointer",
                        }}
                        title="Mark Resolved"
                      >
                        <FaCheck />
                      </button>
                    )}
                  <button
                    onClick={() => onDelete(contact._id)}
                    style={{
                      padding: "0.4rem 0.8rem",
                      background: "#ef4444",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                    title="Delete"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

// Dashboard Tab Component
const DashboardTab = ({ data, isDarkMode }) => {
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);
  const getAvatar = (name) => getAvatarDataUrl(name, 40);

  return (
    <div
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem" }}
    >
      <div
        style={{
          background: getBgColor(),
          padding: "1.5rem",
          borderRadius: "20px",
          border: `1px solid ${getBorderColor()}`,
        }}
      >
        <h3
          style={{
            color: getTextColor(),
            marginBottom: "1rem",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <FaUsers color="#8b5cf6" /> Recent Users
        </h3>
        {data.recentUsers.map((user) => (
          <div
            key={user._id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0.8rem 0",
              borderBottom: `1px solid ${getBorderColor()}`,
            }}
          >
            <div>
              <div style={{ fontWeight: "500", color: getTextColor() }}>
                {user.name}
              </div>
              <div
                style={{
                  fontSize: "0.85rem",
                  color: getTextSecondaryStatic(isDarkMode),
                }}
              >
                {user.email}
              </div>
            </div>
            <div
              style={{
                fontSize: "0.85rem",
                color: getTextSecondaryStatic(isDarkMode),
              }}
            >
              {new Date(user.createdAt).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
      <div
        style={{
          background: getBgColor(),
          padding: "1.5rem",
          borderRadius: "20px",
          border: `1px solid ${getBorderColor()}`,
        }}
      >
        <h3
          style={{
            color: getTextColor(),
            marginBottom: "1rem",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <FaTrophy color="#f59e0b" /> Top Contributors
        </h3>
        {data.topContributors.map((user) => (
          <div
            key={user._id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              padding: "0.8rem 0",
              borderBottom: `1px solid ${getBorderColor()}`,
            }}
          >
            <img
              src={user.profilePicture || getAvatar(user.name)}
              alt={user.name}
              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
            />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "500", color: getTextColor() }}>
                {user.name}
              </div>
              <div
                style={{
                  fontSize: "0.85rem",
                  color: getTextSecondaryStatic(isDarkMode),
                }}
              >
                {user.contributions.notesUploaded} notes uploaded
              </div>
            </div>
            <FaStar color="#f59e0b" />
          </div>
        ))}
      </div>
    </div>
  );
};

// Pending Notes Tab Component
const PendingNotesTab = ({
  notes,
  onApprove,
  onReject,
  onDelete,
  selectedNotes,
  setSelectedNotes,
  showBulkActions,
  setShowBulkActions,
  onBulkApprove,
  onBulkReject,
  isAdmin,
  isDarkMode,
}) => {
  const toggleSelectNote = (noteId) => {
    if (selectedNotes.includes(noteId))
      setSelectedNotes(selectedNotes.filter((id) => id !== noteId));
    else setSelectedNotes([...selectedNotes, noteId]);
  };
  const toggleSelectAll = () => {
    if (selectedNotes.length === notes.length) setSelectedNotes([]);
    else setSelectedNotes(notes.map((n) => n._id));
  };
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  if (notes.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "3rem",
          background: getBgColor(),
          borderRadius: "20px",
          border: `1px solid ${getBorderColor()}`,
        }}
      >
        <FaCheckCircle size={50} color="#10b981" />
        <h3 style={{ margin: "1rem 0", color: getTextColor() }}>
          All Caught Up!
        </h3>
        <p style={{ color: getTextSecondaryStatic(isDarkMode) }}>
          No pending notes to review
        </p>
      </div>
    );
  }

  return (
    <div>
      {notes.length > 0 && (
        <div
          style={{
            background: isDarkMode ? "rgba(139,92,246,0.1)" : "#f8f9fa",
            padding: "1rem",
            borderRadius: "12px",
            marginBottom: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                color: getTextColor(),
              }}
            >
              <input
                type="checkbox"
                checked={selectedNotes.length === notes.length}
                onChange={toggleSelectAll}
              />{" "}
              <span>Select All ({selectedNotes.length} selected)</span>
            </label>
            {selectedNotes.length > 0 && (
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <button
                  onClick={onBulkApprove}
                  style={{
                    padding: "0.3rem 1rem",
                    background: "#10b981",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Approve Selected
                </button>
                <button
                  onClick={onBulkReject}
                  style={{
                    padding: "0.3rem 1rem",
                    background: "#ef4444",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Reject Selected
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      <div style={{ display: "grid", gap: "1rem" }}>
        {notes.map((note) => (
          <PendingNoteCard
            key={note._id}
            note={note}
            onApprove={() => onApprove(note._id)}
            onReject={() => onReject(note)}
            onDelete={() => onDelete && onDelete(note)}
            isSelected={selectedNotes.includes(note._id)}
            onSelect={() => toggleSelectNote(note._id)}
            isAdmin={isAdmin}
            isDarkMode={isDarkMode}
          />
        ))}
      </div>
    </div>
  );
};

// Pending Note Card Component
const PendingNoteCard = ({
  note,
  onApprove,
  onReject,
  onDelete,
  isSelected,
  onSelect,
  isAdmin,
  isDarkMode,
}) => {
  const getFileIcon = (type) => {
    if (type?.includes("pdf")) return <FaFilePdf color="#ef4444" />;
    if (type?.includes("doc")) return <FaFileWord color="#3b82f6" />;
    if (type?.includes("ppt")) return <FaFilePowerpoint color="#f59e0b" />;
    return <FaFileAlt color="#8b5cf6" />;
  };
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        background: getBgColor(),
        padding: "1rem",
        borderRadius: "16px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        border: `1px solid #f59e0b`,
        position: "relative",
      }}
    >
      <div style={{ display: "flex", alignItems: "start", gap: "1rem" }}>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onSelect}
          style={{ marginTop: "0.3rem" }}
        />
        <div style={{ fontSize: "1.5rem" }}>{getFileIcon(note.fileType)}</div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <div>
              <h3 style={{ color: getTextColor(), marginBottom: "0.5rem" }}>
                {note.title}
              </h3>
              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  flexWrap: "wrap",
                  marginBottom: "0.5rem",
                }}
              >
                <span
                  style={{
                    background: "#8b5cf6",
                    color: "white",
                    padding: "0.2rem 0.5rem",
                    borderRadius: "5px",
                    fontSize: "0.8rem",
                  }}
                >
                  {note.subjectCode}
                </span>
                <span
                  style={{
                    background: isDarkMode ? "#25253a" : "#f0f0f0",
                    color: getTextSecondaryStatic(isDarkMode),
                    padding: "0.2rem 0.5rem",
                    borderRadius: "5px",
                    fontSize: "0.8rem",
                  }}
                >
                  {note.branch} - Sem {note.semester}
                </span>
                {note.module && (
                  <span
                    style={{
                      background: isDarkMode ? "#25253a" : "#f0f0f0",
                      color: getTextSecondaryStatic(isDarkMode),
                      padding: "0.2rem 0.5rem",
                      borderRadius: "5px",
                      fontSize: "0.8rem",
                    }}
                  >
                    Module {note.module}
                  </span>
                )}
              </div>
              <p
                style={{
                  color: getTextSecondaryStatic(isDarkMode),
                  marginBottom: "0.5rem",
                  fontSize: "0.85rem",
                }}
              >
                <strong>Uploaded by:</strong> {note.uploadedBy?.name} (
                {note.uploadedBy?.email})
              </p>
              <p
                style={{
                  color: getTextSecondaryStatic(isDarkMode),
                  marginBottom: "0.5rem",
                  fontSize: "0.85rem",
                }}
              >
                <strong>USN:</strong> {note.uploadedBy?.usn}
              </p>
              <p
                style={{
                  color: getTextSecondaryStatic(isDarkMode),
                  fontSize: "0.8rem",
                }}
              >
                Uploaded: {new Date(note.createdAt).toLocaleString()}
              </p>
            </div>
            <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
              <button
                onClick={() => window.open(`/notes/${note._id}`, "_blank")}
                style={{
                  padding: "0.4rem 0.8rem",
                  background: "#06b6d4",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.3rem",
                }}
              >
                <FaEye /> View
              </button>
              <button
                onClick={onApprove}
                style={{
                  padding: "0.4rem 0.8rem",
                  background: "#10b981",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.3rem",
                }}
              >
                <FaCheck /> Approve
              </button>
              <button
                onClick={onReject}
                style={{
                  padding: "0.4rem 0.8rem",
                  background: "#f59e0b",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.3rem",
                }}
              >
                <FaTimes /> Reject
              </button>
              {isAdmin && (
                <button
                  onClick={onDelete}
                  style={{
                    padding: "0.4rem 0.8rem",
                    background: "#ef4444",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.3rem",
                  }}
                >
                  <FaTrash /> Delete
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

// Reported Notes Tab Component
const ReportedNotesTab = ({ notes, onModerate, isAdmin, isDarkMode }) => {
  const [selectedNote, setSelectedNote] = useState(null);
  const [showModerateModal, setShowModerateModal] = useState(false);
  const [moderationAction, setModerationAction] = useState("");
  const [moderationNote, setModerationNote] = useState("");
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  const handleModerate = () => {
    if (!moderationAction) {
      toast.error("Please select an action");
      return;
    }
    onModerate(selectedNote._id, moderationAction, moderationNote);
    setShowModerateModal(false);
    setSelectedNote(null);
    setModerationAction("");
    setModerationNote("");
  };

  const getReportReasons = (note) => {
    const reasons = note.reports?.map((r) => r.reason) || [];
    return [...new Set(reasons)].join(", ");
  };

  if (notes.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "3rem",
          background: getBgColor(),
          borderRadius: "20px",
          border: `1px solid ${getBorderColor()}`,
        }}
      >
        <FaCheckCircle size={50} color="#10b981" />
        <h3 style={{ margin: "1rem 0", color: getTextColor() }}>
          No Reported Notes
        </h3>
        <p style={{ color: getTextSecondaryStatic(isDarkMode) }}>
          All notes are clean! No reports to review.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: "grid", gap: "1rem" }}>
        {notes.map((note) => (
          <ReportedNoteCard
            key={note._id}
            note={note}
            onModerate={() => {
              setSelectedNote(note);
              setShowModerateModal(true);
            }}
            reportReasons={getReportReasons(note)}
            isAdmin={isAdmin}
            isDarkMode={isDarkMode}
          />
        ))}
      </div>
      {showModerateModal && selectedNote && (
        <ModerateModal
          title="Moderate Note"
          item={selectedNote}
          action={moderationAction}
          setAction={setModerationAction}
          note={moderationNote}
          setNote={setModerationNote}
          onConfirm={handleModerate}
          onClose={() => {
            setShowModerateModal(false);
            setSelectedNote(null);
          }}
          isAdmin={isAdmin}
          isDarkMode={isDarkMode}
        />
      )}
    </div>
  );
};

// Reported Note Card Component
const ReportedNoteCard = ({
  note,
  onModerate,
  reportReasons,
  isAdmin,
  isDarkMode,
}) => {
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        background: getBgColor(),
        padding: "1rem",
        borderRadius: "16px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        borderLeft: "4px solid #ef4444",
        borderTop: `1px solid ${getBorderColor()}`,
        borderRight: `1px solid ${getBorderColor()}`,
        borderBottom: `1px solid ${getBorderColor()}`,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        <div style={{ flex: 1 }}>
          <h3 style={{ color: getTextColor(), marginBottom: "0.5rem" }}>
            {note.title}
          </h3>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              flexWrap: "wrap",
              marginBottom: "0.5rem",
            }}
          >
            <span
              style={{
                background: "#8b5cf6",
                color: "white",
                padding: "0.2rem 0.5rem",
                borderRadius: "5px",
                fontSize: "0.8rem",
              }}
            >
              {note.subjectCode}
            </span>
            <span
              style={{
                background: isDarkMode ? "#25253a" : "#f0f0f0",
                color: getTextSecondaryStatic(isDarkMode),
                padding: "0.2rem 0.5rem",
                borderRadius: "5px",
                fontSize: "0.8rem",
              }}
            >
              {note.branch} - Sem {note.semester}
            </span>
          </div>
          <p
            style={{
              color: getTextSecondaryStatic(isDarkMode),
              marginBottom: "0.5rem",
              fontSize: "0.9rem",
            }}
          >
            {note.description?.substring(0, 200)}...
          </p>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
              marginBottom: "0.5rem",
            }}
          >
            <span
              style={{
                background: isDarkMode ? "#25253a" : "#f8f9fa",
                padding: "0.2rem 0.5rem",
                borderRadius: "5px",
                fontSize: "0.8rem",
                color: getTextSecondaryStatic(isDarkMode),
              }}
            >
              <FaFlag color="#ef4444" /> Reported by {note.reports?.length || 0}{" "}
              users
            </span>
            <span
              style={{
                background: isDarkMode ? "#25253a" : "#f8f9fa",
                padding: "0.2rem 0.5rem",
                borderRadius: "5px",
                fontSize: "0.8rem",
                color: getTextSecondaryStatic(isDarkMode),
              }}
            >
              Reason: {reportReasons}
            </span>
          </div>
          <div
            style={{
              fontSize: "0.8rem",
              color: getTextSecondaryStatic(isDarkMode),
            }}
          >
            Uploaded by: {note.uploadedBy?.name} ({note.uploadedBy?.email})
          </div>
        </div>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <button
            onClick={() => window.open(`/notes/${note._id}`, "_blank")}
            style={{
              padding: "0.4rem 0.8rem",
              background: "#06b6d4",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "0.3rem",
            }}
          >
            <FaEye /> View
          </button>
          <button
            onClick={onModerate}
            style={{
              padding: "0.4rem 0.8rem",
              background: "#8b5cf6",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "0.3rem",
            }}
          >
            <FaEdit /> Moderate
          </button>
        </div>
      </div>
    </motion.div>
  );
};

// Reported Comments Tab Component
const ReportedCommentsTab = ({ comments, onModerate, isAdmin, isDarkMode }) => {
  const [selectedComment, setSelectedComment] = useState(null);
  const [showModerateModal, setShowModerateModal] = useState(false);
  const [moderationAction, setModerationAction] = useState("");
  const [moderationNote, setModerationNote] = useState("");
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  const handleModerate = () => {
    if (!moderationAction) {
      toast.error("Please select an action");
      return;
    }
    onModerate(selectedComment._id, moderationAction, moderationNote);
    setShowModerateModal(false);
    setSelectedComment(null);
    setModerationAction("");
    setModerationNote("");
  };

  const getReportReasons = (comment) => {
    const reasons = comment.reports?.map((r) => r.reason) || [];
    return [...new Set(reasons)].join(", ");
  };

  if (comments.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "3rem",
          background: getBgColor(),
          borderRadius: "20px",
          border: `1px solid ${getBorderColor()}`,
        }}
      >
        <FaCheckCircle size={50} color="#10b981" />
        <h3 style={{ margin: "1rem 0", color: getTextColor() }}>
          No Reported Comments
        </h3>
        <p style={{ color: getTextSecondaryStatic(isDarkMode) }}>
          All comments are clean! No reports to review.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: "grid", gap: "1rem" }}>
        {comments.map((comment) => (
          <ReportedCommentCard
            key={comment._id}
            comment={comment}
            onModerate={() => {
              setSelectedComment(comment);
              setShowModerateModal(true);
            }}
            reportReasons={getReportReasons(comment)}
            isAdmin={isAdmin}
            isDarkMode={isDarkMode}
          />
        ))}
      </div>
      {showModerateModal && selectedComment && (
        <ModerateModal
          title="Moderate Comment"
          item={selectedComment}
          action={moderationAction}
          setAction={setModerationAction}
          note={moderationNote}
          setNote={setModerationNote}
          onConfirm={handleModerate}
          onClose={() => {
            setShowModerateModal(false);
            setSelectedComment(null);
          }}
          isAdmin={isAdmin}
          isDarkMode={isDarkMode}
        />
      )}
    </div>
  );
};

// Reported Comment Card Component
const ReportedCommentCard = ({
  comment,
  onModerate,
  reportReasons,
  isAdmin,
  isDarkMode,
}) => {
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);
  const getAvatar = (name) => getAvatarDataUrl(name, 40);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        background: getBgColor(),
        padding: "1rem",
        borderRadius: "16px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        borderLeft: "4px solid #ef4444",
        borderTop: `1px solid ${getBorderColor()}`,
        borderRight: `1px solid ${getBorderColor()}`,
        borderBottom: `1px solid ${getBorderColor()}`,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.8rem",
              marginBottom: "0.5rem",
            }}
          >
            <img
              src={
                comment.user?.profilePicture || getAvatar(comment.user?.name)
              }
              alt={comment.user?.name}
              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
            />
            <div>
              <strong style={{ color: getTextColor() }}>
                {comment.user?.name}
              </strong>
              <span
                style={{
                  color: getTextSecondaryStatic(isDarkMode),
                  fontSize: "0.8rem",
                  marginLeft: "0.5rem",
                }}
              >
                {new Date(comment.createdAt).toLocaleString()}
              </span>
            </div>
          </div>
          <p
            style={{
              color: getTextColor(),
              marginBottom: "0.5rem",
              lineHeight: "1.5",
            }}
          >
            {comment.content}
          </p>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
              marginBottom: "0.5rem",
            }}
          >
            <span
              style={{
                background: isDarkMode ? "#25253a" : "#f8f9fa",
                padding: "0.2rem 0.5rem",
                borderRadius: "5px",
                fontSize: "0.8rem",
                color: getTextSecondaryStatic(isDarkMode),
              }}
            >
              <FaFlag color="#ef4444" /> Reported by{" "}
              {comment.reports?.length || 0} users
            </span>
            <span
              style={{
                background: isDarkMode ? "#25253a" : "#f8f9fa",
                padding: "0.2rem 0.5rem",
                borderRadius: "5px",
                fontSize: "0.8rem",
                color: getTextSecondaryStatic(isDarkMode),
              }}
            >
              Reason: {reportReasons}
            </span>
          </div>
          <div
            style={{
              fontSize: "0.8rem",
              color: getTextSecondaryStatic(isDarkMode),
            }}
          >
            Note:{" "}
            <Link
              to={`/notes/${comment.note?._id}`}
              style={{ color: "#8b5cf6" }}
            >
              {comment.note?.title}
            </Link>
          </div>
        </div>
        <button
          onClick={onModerate}
          style={{
            padding: "0.4rem 0.8rem",
            background: "#8b5cf6",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "0.3rem",
          }}
        >
          <FaEdit /> Moderate
        </button>
      </div>
    </motion.div>
  );
};

// Users Tab Component
const UsersTab = ({
  users,
  onToggleStatus,
  onChangeRole,
  currentAdmin,
  isDarkMode,
}) => {
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);
  const getAvatar = (name) => getAvatarDataUrl(name, 30);

  return (
    <div
      style={{
        background: getBgColor(),
        borderRadius: "20px",
        overflow: "auto",
        border: `1px solid ${getBorderColor()}`,
      }}
    >
      <table
        style={{ width: "100%", borderCollapse: "collapse", minWidth: "800px" }}
      >
        <thead>
          <tr
            style={{
              background: isDarkMode ? "rgba(139,92,246,0.1)" : "#f8f9fa",
              borderBottom: `2px solid ${getBorderColor()}`,
            }}
          >
            <th
              style={{
                padding: "0.8rem",
                textAlign: "left",
                color: getTextColor(),
              }}
            >
              User
            </th>
            <th
              style={{
                padding: "0.8rem",
                textAlign: "left",
                color: getTextColor(),
              }}
            >
              Email
            </th>
            <th
              style={{
                padding: "0.8rem",
                textAlign: "left",
                color: getTextColor(),
              }}
            >
              USN
            </th>
            <th
              style={{
                padding: "0.8rem",
                textAlign: "left",
                color: getTextColor(),
              }}
            >
              Branch
            </th>
            <th
              style={{
                padding: "0.8rem",
                textAlign: "left",
                color: getTextColor(),
              }}
            >
              Semester
            </th>
            <th
              style={{
                padding: "0.8rem",
                textAlign: "left",
                color: getTextColor(),
              }}
            >
              Role
            </th>
            <th
              style={{
                padding: "0.8rem",
                textAlign: "left",
                color: getTextColor(),
              }}
            >
              Status
            </th>
            <th
              style={{
                padding: "0.8rem",
                textAlign: "left",
                color: getTextColor(),
              }}
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr
              key={user._id}
              style={{ borderBottom: `1px solid ${getBorderColor()}` }}
            >
              <td style={{ padding: "0.8rem" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <img
                    src={user.profilePicture || getAvatar(user.name)}
                    alt={user.name}
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                    }}
                  />
                  {user.name}
                </div>
              </td>
              <td style={{ padding: "0.8rem", color: getTextColor() }}>
                {user.email}
              </td>
              <td style={{ padding: "0.8rem", color: getTextColor() }}>
                {user.usn}
              </td>
              <td style={{ padding: "0.8rem", color: getTextColor() }}>
                {user.branch}
              </td>
              <td style={{ padding: "0.8rem", color: getTextColor() }}>
                {user.semester}
              </td>
              <td style={{ padding: "0.8rem" }}>
                <select
                  value={user.role}
                  onChange={(e) => onChangeRole(user._id, e.target.value)}
                  disabled={user._id === currentAdmin?._id}
                  style={{
                    padding: "0.3rem",
                    borderRadius: "8px",
                    border: `1px solid ${getBorderColor()}`,
                    background: getInputBackgroundStatic(isDarkMode),
                    color: getTextColor(),
                  }}
                >
                  <option value="user">User</option>
                  <option value="moderator">Moderator</option>
                  <option value="admin">Admin</option>
                </select>
              </td>
              <td style={{ padding: "0.8rem" }}>
                <span
                  style={{
                    padding: "0.2rem 0.6rem",
                    borderRadius: "20px",
                    background: user.isActive ? "#10b981" : "#ef4444",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                >
                  {user.isActive ? "Active" : "Inactive"}
                </span>
              </td>
              <td style={{ padding: "0.8rem" }}>
                <button
                  onClick={() => onToggleStatus(user._id)}
                  disabled={user._id === currentAdmin?._id}
                  style={{
                    padding: "0.3rem 0.8rem",
                    background: user.isActive ? "#ef4444" : "#10b981",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor:
                      user._id === currentAdmin?._id
                        ? "not-allowed"
                        : "pointer",
                    opacity: user._id === currentAdmin?._id ? 0.5 : 1,
                  }}
                >
                  {user.isActive ? "Deactivate" : "Activate"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Muted/Banned Users Tab Component
const MutedBannedUsersTab = ({
  mutedUsers,
  bannedUsers,
  onUnmute,
  onUnban,
  onRefresh,
  mutedSearchTerm,
  setMutedSearchTerm,
  bannedSearchTerm,
  setBannedSearchTerm,
  loading,
  isDarkMode,
}) => {
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  if (loading)
    return (
      <div style={{ textAlign: "center", padding: "3rem" }}>
        <FaSpinner
          style={{
            animation: "spin 1s linear infinite",
            fontSize: "2rem",
            color: "#8b5cf6",
          }}
        />
      </div>
    );

  return (
    <div>
      <div style={{ marginBottom: "2rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <h2
            style={{
              color: "#f59e0b",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <FaMicrophoneSlash /> Muted Users ({mutedUsers.length})
          </h2>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              background: getBgColor(),
              padding: "0.3rem 0.8rem",
              borderRadius: "20px",
              border: `1px solid ${getBorderColor()}`,
            }}
          >
            <FaSearch size={12} color={getTextSecondaryStatic(isDarkMode)} />
            <input
              type="text"
              placeholder="Search muted users..."
              value={mutedSearchTerm}
              onChange={(e) => setMutedSearchTerm(e.target.value)}
              style={{
                border: "none",
                background: "none",
                outline: "none",
                fontSize: "0.85rem",
                width: "200px",
                color: getTextColor(),
              }}
            />
          </div>
        </div>
        {mutedUsers.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "2rem",
              background: getBgColor(),
              borderRadius: "16px",
              border: `1px solid ${getBorderColor()}`,
              color: getTextSecondaryStatic(isDarkMode),
            }}
          >
            No muted users found
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gap: "1rem",
              gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
            }}
          >
            {mutedUsers.map((user) => (
              <MutedBannedUserCard
                key={user._id}
                user={user}
                type="muted"
                onAction={onUnmute}
                actionIcon={<FaMicrophone />}
                actionLabel="Unmute"
                actionColor="#10b981"
                isDarkMode={isDarkMode}
              />
            ))}
          </div>
        )}
      </div>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <h2
            style={{
              color: "#ef4444",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <FaBan /> Banned Users ({bannedUsers.length})
          </h2>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              background: getBgColor(),
              padding: "0.3rem 0.8rem",
              borderRadius: "20px",
              border: `1px solid ${getBorderColor()}`,
            }}
          >
            <FaSearch size={12} color={getTextSecondaryStatic(isDarkMode)} />
            <input
              type="text"
              placeholder="Search banned users..."
              value={bannedSearchTerm}
              onChange={(e) => setBannedSearchTerm(e.target.value)}
              style={{
                border: "none",
                background: "none",
                outline: "none",
                fontSize: "0.85rem",
                width: "200px",
                color: getTextColor(),
              }}
            />
          </div>
        </div>
        {bannedUsers.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "2rem",
              background: getBgColor(),
              borderRadius: "16px",
              border: `1px solid ${getBorderColor()}`,
              color: getTextSecondaryStatic(isDarkMode),
            }}
          >
            No banned users found
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gap: "1rem",
              gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
            }}
          >
            {bannedUsers.map((user) => (
              <MutedBannedUserCard
                key={user._id}
                user={user}
                type="banned"
                onAction={onUnban}
                actionIcon={<FaUserPlus />}
                actionLabel="Unban"
                actionColor="#10b981"
                isDarkMode={isDarkMode}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// Muted/Banned User Card Component
const MutedBannedUserCard = ({
  user,
  type,
  onAction,
  actionIcon,
  actionLabel,
  actionColor,
  isDarkMode,
}) => {
  const getAvatarUrl = (name) => {
    const initials =
      name
        ?.split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .substring(0, 2) || "U";
    return `https://ui-avatars.com/api/?name=${initials}&background=8b5cf6&color=fff&length=2&size=40`;
  };
  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString() : "Indefinite";
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ y: -2 }}
      style={{
        background: getBgColor(),
        borderRadius: "16px",
        padding: "1rem",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        borderLeft: `4px solid ${type === "muted" ? "#f59e0b" : "#ef4444"}`,
        borderTop: `1px solid ${getBorderColor()}`,
        borderRight: `1px solid ${getBorderColor()}`,
        borderBottom: `1px solid ${getBorderColor()}`,
        transition: "all 0.3s",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <img
          src={user.profilePicture || getAvatarUrl(user.name)}
          alt={user.name}
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              flexWrap: "wrap",
            }}
          >
            <strong style={{ fontSize: "1rem", color: getTextColor() }}>
              {user.name}
            </strong>
            <span
              style={{
                fontSize: "0.7rem",
                padding: "0.2rem 0.5rem",
                borderRadius: "12px",
                background: type === "muted" ? "#f59e0b" : "#ef4444",
                color: "white",
              }}
            >
              {type === "muted" ? "Muted" : "Banned"}
            </span>
          </div>
          <div
            style={{
              fontSize: "0.8rem",
              color: getTextSecondaryStatic(isDarkMode),
              marginTop: "0.2rem",
            }}
          >
            {user.email} | {user.usn}
          </div>
          <div
            style={{
              fontSize: "0.75rem",
              color: getTextSecondaryStatic(isDarkMode),
              marginTop: "0.2rem",
            }}
          >
            {type === "muted"
              ? `Muted until: ${formatDate(user.mutedUntil)}`
              : `Banned until: ${formatDate(user.bannedUntil)} ${user.banReason ? `| Reason: ${user.banReason}` : ""}`}
          </div>
        </div>
        <button
          onClick={() => onAction(user._id)}
          style={{
            padding: "0.5rem 1rem",
            background: actionColor,
            color: "white",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "0.3rem",
            fontSize: "0.85rem",
            transition: "transform 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.05)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          {actionIcon} {actionLabel}
        </button>
      </div>
    </motion.div>
  );
};

// Moderate Modal Component
const ModerateModal = ({
  title,
  item,
  action,
  setAction,
  note,
  setNote,
  onConfirm,
  onClose,
  isAdmin,
  isDarkMode,
}) => {
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        style={{
          background: getBgColor(),
          padding: "2rem",
          borderRadius: "24px",
          maxWidth: "500px",
          width: "90%",
          border: `1px solid ${getBorderColor()}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ color: getTextColor(), marginBottom: "1rem" }}>{title}</h3>
        <p
          style={{
            color: getTextSecondaryStatic(isDarkMode),
            marginBottom: "1rem",
          }}
        >
          <strong>Item:</strong> {item?.title || item?.content}
        </p>
        <p
          style={{
            color: getTextSecondaryStatic(isDarkMode),
            marginBottom: "1rem",
          }}
        >
          <strong>Reported by:</strong> {item?.reports?.length || 0} users
        </p>
        <div style={{ marginBottom: "1rem" }}>
          <label
            style={{
              display: "block",
              marginBottom: "0.5rem",
              color: getTextColor(),
            }}
          >
            Action:
          </label>
          <select
            value={action}
            onChange={(e) => setAction(e.target.value)}
            style={{
              width: "100%",
              padding: "0.8rem",
              border: `2px solid ${getBorderColor()}`,
              borderRadius: "12px",
              background: getInputBackgroundStatic(isDarkMode),
              color: getTextColor(),
            }}
          >
            <option value="">Select action</option>
            <option value="keep">Keep (Clear reports)</option>
            <option value="warning">Send Warning</option>
            <option value="hide">Hide Content</option>
            {isAdmin && <option value="delete">Delete Permanently</option>}
          </select>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label
            style={{
              display: "block",
              marginBottom: "0.5rem",
              color: getTextColor(),
            }}
          >
            Moderation Note (optional):
          </label>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows="3"
            style={{
              width: "100%",
              padding: "0.8rem",
              border: `2px solid ${getBorderColor()}`,
              borderRadius: "12px",
              background: getInputBackgroundStatic(isDarkMode),
              color: getTextColor(),
            }}
            placeholder="Add a note about this moderation..."
          />
        </div>
        <div
          style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "0.8rem 2rem",
              background: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "0.8rem 2rem",
              background: "#8b5cf6",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Apply Action
          </button>
        </div>
      </motion.div>
    </div>
  );
};

// Reply Modal Component
const ReplyModal = ({
  selectedContact,
  replyText,
  setReplyText,
  setShowReplyModal,
  handleReplyContact,
  isDarkMode,
}) => {
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={() => setShowReplyModal(false)}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        style={{
          background: getBgColor(),
          borderRadius: "24px",
          maxWidth: "500px",
          width: "90%",
          padding: "2rem",
          border: `1px solid ${getBorderColor()}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ marginBottom: "1rem", color: getTextColor() }}>
          Reply to {selectedContact.name}
        </h3>
        <p
          style={{
            color: getTextSecondaryStatic(isDarkMode),
            marginBottom: "0.5rem",
          }}
        >
          <strong>Subject:</strong> {selectedContact.subject}
        </p>
        <div
          style={{
            background: isDarkMode ? "rgba(139,92,246,0.1)" : "#f8f9fa",
            padding: "1rem",
            borderRadius: "12px",
            marginBottom: "1rem",
            border: `1px solid ${getBorderColor()}`,
          }}
        >
          <p style={{ whiteSpace: "pre-wrap", color: getTextColor() }}>
            {selectedContact.message}
          </p>
        </div>
        <textarea
          value={replyText}
          onChange={(e) => setReplyText(e.target.value)}
          rows="4"
          placeholder="Type your reply here..."
          style={{
            width: "100%",
            padding: "0.8rem",
            border: `2px solid ${getBorderColor()}`,
            borderRadius: "12px",
            marginBottom: "1rem",
            resize: "vertical",
            background: getInputBackgroundStatic(isDarkMode),
            color: getTextColor(),
          }}
        />
        <div
          style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
        >
          <button
            onClick={() => setShowReplyModal(false)}
            style={{
              padding: "0.5rem 1rem",
              background: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleReplyContact}
            style={{
              padding: "0.5rem 1rem",
              background: "#10b981",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "0.3rem",
            }}
          >
            <FaPaperPlane /> Send Reply
          </button>
        </div>
      </motion.div>
    </div>
  );
};

// Reject Modal Component
const RejectModal = ({
  isOpen,
  onClose,
  onConfirm,
  reason,
  setReason,
  noteTitle,
  isDarkMode,
}) => {
  if (!isOpen) return null;
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        style={{
          background: getBgColor(),
          padding: "2rem",
          borderRadius: "24px",
          maxWidth: "500px",
          width: "90%",
          border: `1px solid ${getBorderColor()}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <FaExclamationTriangle size={30} color="#f59e0b" />
          <h3 style={{ color: getTextColor() }}>Reject Note</h3>
        </div>
        <p
          style={{
            color: getTextSecondaryStatic(isDarkMode),
            marginBottom: "1rem",
          }}
        >
          Rejecting: <strong>{noteTitle}</strong>
        </p>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter rejection reason..."
          rows="4"
          style={{
            width: "100%",
            padding: "0.8rem",
            border: `2px solid ${getBorderColor()}`,
            borderRadius: "12px",
            marginBottom: "1rem",
            fontSize: "1rem",
            background: getInputBackgroundStatic(isDarkMode),
            color: getTextColor(),
          }}
          autoFocus
        />
        <div
          style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "0.8rem 2rem",
              background: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "0.8rem 2rem",
              background: "#ef4444",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Reject Note
          </button>
        </div>
      </motion.div>
    </div>
  );
};

// Delete Modal Component
const DeleteModal = ({ isOpen, onClose, onConfirm, noteTitle, isDarkMode }) => {
  if (!isOpen) return null;
  const getBgColor = () => getCardBackgroundStatic(isDarkMode);
  const getTextColor = () => getTextColorStatic(isDarkMode);
  const getBorderColor = () => getBorderColorStatic(isDarkMode);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        style={{
          background: getBgColor(),
          padding: "2rem",
          borderRadius: "24px",
          maxWidth: "500px",
          width: "90%",
          border: `1px solid ${getBorderColor()}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <FaExclamationTriangle size={30} color="#ef4444" />
          <h3 style={{ color: getTextColor() }}>Delete Note</h3>
        </div>
        <p
          style={{
            color: getTextSecondaryStatic(isDarkMode),
            marginBottom: "1rem",
          }}
        >
          Are you sure you want to permanently delete{" "}
          <strong>"{noteTitle}"</strong>?
        </p>
        <p
          style={{ color: "#ef4444", marginBottom: "2rem", fontSize: "0.9rem" }}
        >
          This action cannot be undone!
        </p>
        <div
          style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "0.8rem 2rem",
              background: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "0.8rem 2rem",
              background: "#ef4444",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Delete Permanently
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminDashboard;
